const fr = {
  // Header
  'header.customerService': 'Service client',
  "header.freeShipping": "Livraison gratuite à partir de {n} €",
  'header.login': 'Connexion',
  'header.admin': 'Administration',
  'header.myAccount': 'Mon compte',
  'header.myWishlist': 'Ma liste de souhaits',
  'header.myOrders': 'Mes commandes',
  'header.logout': 'Déconnexion',
  'header.parts': 'Pièces détachées',
  'header.wholeCategory': 'Toute la catégorie {name} →',
  'header.brands': 'Marques',
  'header.guides': 'Guides',
  'header.topGuides': 'Les guides les plus lus',
  'header.allGuides': 'Tous les guides & conseils',
  'header.allBrandsAZ': 'Toutes les marques de A à Z ({count})',
  'header.removeVehicle': 'Retirer le véhicule',
  'header.createAccount': 'Créer un compte',
  'header.brandsAZ': 'Marques de A à Z',
  'header.contact': 'Contact',
  'header.language': 'Langue',
  'header.searchPlaceholder': 'Rechercher une pièce, une marque ou une référence',
  'header.searching': 'Recherche...',
  'header.noResults': 'Aucun résultat pour « {term} »',
  'header.openProduct': 'Ouvrir la fiche produit',
  'header.matchesRef': 'Correspond à la réf. {kind}',
  'header.matchesEan': 'Correspond au code EAN ',

  // Footer
  'footer.tagline': '6,7 millions de pièces détachées auto au même endroit',
  'footer.contactUs': 'Nous contacter',
  'footer.contact': 'Contact',
  'footer.shipping': 'Livraison & suivi',
  'footer.returns': 'Garantie & retours',
  'footer.about': 'Qui sommes-nous',
  'footer.sitemap': 'Plan du site',
  'footer.budget': 'Budget entretien par modèle',
  'cookies.title': 'Cookies et mesure d\'audience',
  'cookies.text': 'Nous utilisons des cookies nécessaires au fonctionnement du site (panier, connexion) et, avec votre accord, des cookies de mesure d\'audience (Google Analytics, PostHog) pour améliorer OTOPIECES.COM. Aucune publicité. Votre choix est conservé 6 mois.',
  'cookies.accept': 'Tout accepter',
  'cookies.refuse': 'Refuser',
  'cookies.customise': 'Personnaliser',
  'cookies.save': 'Enregistrer mes choix',
  'cookies.necessary': 'Cookies nécessaires',
  'cookies.necessaryHint': 'toujours actifs (panier, session, préférences)',
  'cookies.analytics': 'Mesure d\'audience',
  'cookies.analyticsHint': 'statistiques anonymes de navigation (Google Analytics, PostHog)',
  'cookies.close': 'Fermer',
  'cookies.manage': 'Gérer les cookies',
  'cookies.statusOn': 'Mesure d\'audience : activée. Vous pouvez modifier votre choix à tout moment.',
  'cookies.statusOff': 'Mesure d\'audience : refusée. Seuls les cookies nécessaires sont utilisés.',
  'cookies.statusNone': 'Vous n\'avez pas encore fait de choix : seuls les cookies nécessaires sont actifs.',
  'footer.securePayments': 'Paiements sécurisés :',
  'footer.fastShipping': "Livraison dans toute l'Europe",
  'footer.rights': '© 2026 OTOPIECES.COM. Tous droits réservés.',
  'footer.trademarks': 'Toutes les marques sont la propriété de leurs détenteurs respectifs.',

  // Common
  'common.ref': 'Réf.',
  'common.addToCart': 'Ajouter au panier',
  'common.free': 'Gratuite',
  'common.subtotal': 'Sous-total',
  'common.shipping': 'Livraison',
  'common.total': 'Total',
  'common.vatIncluded': 'TVA incluse',
  'common.back': 'Retour',
  'common.continueShopping': 'Continuer les achats',
  'common.outOfStock': 'Rupture de stock',
  'common.inStock': 'En stock',
  'common.lowStock': 'Plus que {n} en stock',
  'common.supplierStock': 'Chez notre fournisseur · sous {n} j',
  'common.compatible': 'Compatible',
  'common.cancel': 'Annuler',
  'common.apply': 'Appliquer',
  'common.home': 'Accueil',
  'common.breadcrumb': "Fil d'Ariane",
  'common.unit': 'Unité',
  'common.perUnit': '/ unité',
  'common.discount': 'Remise ({code})',
  'common.packAvailable': 'Dispo en {label}',
  'common.equivalentOther': "Équivalent d'une autre marque (même réf. OEM)",
  'common.oem': 'OEM ',
  'common.alternative': 'alternative ',
  'common.bestPrice': 'Meilleur prix du marché',
  'common.bestPriceTitle': 'Prix comparé à {n} concurrent(s){date} : OTOPIECES est le moins cher.',
  'common.onDate': ' le {date}',

  // Stock labels
  'stock.out': 'Rupture de stock',
  'stock.supplier': { one: 'Disponible chez notre fournisseur — expédié sous {n} jour', other: 'Disponible chez notre fournisseur — expédié sous {n} jours' },
  'stock.low': 'Plus que {n} en stock',
  'stock.lowSupplier': ' (+{s} chez notre fournisseur sous {lead} j)',
  'stock.in': 'En stock',

  // Product page
  'product.notFound': 'Produit introuvable',
  'product.backHome': "Retour à l'accueil",
  'product.allParts': 'Toutes les pièces {brand}',
  'product.manufacturerRef': 'Réf. fabricant :',
  'product.equivalentRef': 'Référence équivalente',
  'product.oemRef': 'Référence OEM constructeur',
  'product.moreOem': { one: '+{n} autre réf. OEM', other: '+{n} autres réf. OEM' },
  'product.reviews': { one: '{n} avis', other: '{n} avis' },
  'product.compatibleWith': 'Compatible avec votre ',
  'product.notGuaranteed': 'Non garanti pour votre ',
  'product.ttcExclShipping': 'TTC, hors livraison',
  'product.tierBadge': '−{pct}% dès {n}',
  'product.cheaperAlt': 'Alternative dès {price} € chez {brand}',
  'product.cheaperAltCompat': 'Alternative compatible dès {price} € chez {brand}',
  'product.soldBy': 'Vendu par',
  'product.soldByDetail': 'Vendu par {n}{label} — {total} € {unitLabel}, soit {unit} € / unité',
  'product.theN': 'les {n}',
  'product.totalFor': 'Total pour {n} :',
  'product.insteadOf': 'au lieu de {price} €',
  'product.outOfStockHint': 'Rupture de stock temporaire',
  'product.photoCheck': 'Vérifier ma pièce par photo',
  'product.added': 'Ajouté au panier',
  'product.addPack': 'Ajouter {qty}{label}',
  'product.viewCart': 'Voir le panier',
  'product.delivery': 'Livraison 2-5 jours',
  "product.deliverySub": "Gratuite dès {n} €",
  'product.return': 'Retour 14 jours',
  'product.returnSub': 'Satisfait ou remboursé',
  'product.warranty': 'Garantie 2 ans',
  'product.warrantySub': 'Pièces certifiées',
  'product.description': 'Description',
  'product.faqTitle': 'Questions fréquentes sur ce produit',
  'product.share': 'Partager',
  'product.shareCopy': 'Copier le lien',
  'product.shareCopied': 'Lien copié',
  'product.specs': 'Caractéristiques',
  'product.compatibleVehicles': 'Véhicules compatibles',
  'product.compatVerified': { one: 'Compatibilités vérifiées via {n} pièce équivalente', other: 'Compatibilités vérifiées via {n} pièces équivalentes' },
  'product.universal': 'Produit universel : compatible avec tous les véhicules.',
  'product.allModels': 'Tous les modèles',
  'spec.manufacturer': 'Fabricant',
  'spec.reference': 'Référence',
  'spec.otherRefs': 'Autres références',
  'spec.oemRefs': 'Références OEM',
  'spec.category': 'Catégorie',
  'product.alsoIn': 'Également dans',
  'product.relatedSubs': 'Autres pièces : {cat}',
  'product.relatedAll': 'Toute la catégorie {cat}',
  'product.relatedMore': 'Voir toutes (+{n})',
  'product.relatedLess': 'Voir moins',
  'product.relatedVehicles': 'Pièces compatibles par véhicule',
  'product.guides': 'Guides & conseils : {part}',
  'product.readGuide': 'Lire le guide',
  'cat.popularModels': '{part} pour les modèles les plus demandés',
  'spec.features': 'Caractéristiques',
  'spec.ean': 'Numéro de EAN',
  'spec.condition': 'État',
  'spec.new': 'Neuf',
  'spec.soldBy': 'Vendu par',
  'spec.packagings': 'Conditionnements',
  'spec.avgRating': 'Note moyenne',
  'spec.avgRatingValue': '{r} / 5 ({n} avis)',
  'spec.warranty': 'Garantie',
  'spec.warrantyValue': '2 ans minimum',
  'spec.availability': 'Disponibilité',

  // Product sub-components
  'pack.title': 'Conditionnement',
  'pack.units': '{n} unités · {price} € / unité',
  'pack.unitPrice': 'Prix unitaire',
  'pack.insufficient': ' · stock insuffisant',
  'tiers.title': 'Prix dégressifs — achetez plus, payez moins',
  'tiers.quantity': 'Quantité',
  'tiers.unitPrice': 'Prix unitaire',
  'tiers.saving': 'Économie',
  'tiers.range': '{a} à {b}',
  'tiers.andMore': '{a} et +',
  'tiers.note': "Remise appliquée automatiquement dans le panier sur le prix à l'unité.",
  'pro.ht': 'soit {price} € HT',
  'pro.discount': 'Prix pro −{pct} % : {price} € TTC au panier',
  'wishlist.added': 'Ajouté à votre liste de souhaits',
  'wishlist.removed': 'Retiré de votre liste de souhaits',
  'wishlist.error': 'Impossible de mettre à jour la liste de souhaits',
  'wishlist.remove': 'Retirer de la liste de souhaits',
  'wishlist.add': 'Ajouter à la liste de souhaits',
  'wishlist.inList': 'Dans ma liste',
  'wishlist.addToList': 'Ajouter à ma liste',
  'faq.askPrompt': 'Une question sur cette pièce ? Posez-la, nous répondons sous 24 h.',
  'faq.ask': 'Poser une question',
  'faq.title': 'Questions fréquentes',
  'faq.seeAll': 'Voir toutes les questions ({n})',
  'faq.answerFrom': 'Réponse de {author}',
  'tyre.howMany': 'Combien de pneus ?',
  'tyre.one': '1 pneu',
  'tyre.set4': 'Lot de 4 pneus',
  'tyre.n': '{n} pneus',
  'tyre.perTyre': '/ pneu',
  'tyre.insufficient': 'Stock insuffisant pour un lot de 4 — contactez-nous pour un réassort.',
  'equiv.title': "Cette pièce existe aussi chez d'autres marques",
  'equiv.count': { one: '{n} alternative', other: '{n} alternatives' },
  'equiv.cheaper': { one: ' · {n} moins chère', other: ' · {n} moins chères' },
  'equiv.compare': 'Comparer côte à côte ({n})',
  'similar.title': 'Produits similaires',
  'similar.sub': "— {category} d'autres marques compatibles avec les mêmes véhicules",
  'similar.subVehicle': '— compatibles avec votre {vehicle}',
  'recent.title': 'Récemment consultés',
  'recent.clear': 'Effacer',
  'fitments.count': '{n} motorisation(s) · {b} marque(s)',
  'fitments.filter': 'Filtrer (marque, modèle, moteur)',
  'fitments.models': { one: '· {n} modèle', other: '· {n} modèles' },
  'fitments.noMatch': 'Aucune motorisation ne correspond à « {q} ».',
  'reviews.title': 'Avis clients',
  'reviews.outOf5': 'sur 5',
  'reviews.loginPrompt': 'pour laisser un avis sur un produit commandé.',
  'reviews.login': 'Connectez-vous',
  'reviews.already': 'Merci, vous avez déjà évalué ce produit.',
  'reviews.yourRating': 'Votre note *',
  'reviews.titleField': 'Titre',
  'reviews.titlePlaceholder': 'Résumé en quelques mots',
  'reviews.comment': 'Commentaire *',
  'reviews.commentPlaceholder': 'Qualité, montage, rapport qualité/prix...',
  'reviews.published': 'Votre avis a été publié. Merci !',
  'reviews.empty': 'Aucun avis pour le moment. Soyez le premier à partager votre expérience !',
  'reviews.sortBy': 'Trier par',
  'reviews.merchantCollected': 'Avis recueilli par le marchand',
  'reviews.verified': 'Achat vérifié',
  'reviews.replyFrom': "Réponse d'{author}",
  'reviews.sort.recent': 'Plus récents',
  'reviews.sort.helpful': 'Plus utiles',
  'reviews.sort.photos': "Avec photos d'abord",
  'reviews.share': 'Partager',
  'home.google.badge': { one: 'sur Google · {n} avis', other: 'sur Google · {n} avis' },
  'brand.trust.title': 'Score de confiance',
  'brand.trust.summary': { one: '{n} avis vérifié sur {p} produit(s) notés', other: '{n} avis vérifiés sur {p} produit(s) notés' },
  'brand.trust.recommended': { one: '{n} produit recommandé par nos clients', other: '{n} produits recommandés par nos clients' },
  'product.topBadge': 'Recommandé par nos clients',
  'product.topBadgeHint': 'Note {r}/5 sur {n} avis vérifiés',
  'reviews.translate': 'Traduire',
  'reviews.translatedByAi': 'Traduit automatiquement',
  'reviews.originalShown': 'Texte original',
  'reviews.showOriginal': 'Voir l\'original',
  'reviews.showTranslation': 'Voir la traduction',
  'reviews.translateError': 'Traduction indisponible',
  'home.google.title': 'Note Google',
  'home.google.count': { one: '{n} avis Google', other: '{n} avis Google' },
  'home.google.link': 'Voir tous les avis sur Google',
  'reviews.pendingNotice': 'Merci ! Votre avis a bien été reçu : il sera publié après une courte vérification par notre équipe.',
  'home.wall.kicker': 'Avis vérifiés',
  'home.wall.title': 'Ils nous font confiance',
  'home.wall.summary': { one: 'sur {n} avis vérifié', other: 'sur {n} avis vérifiés' },
  'reviews.shareText': 'Mon avis {stars} sur {product} : « {comment} »',
  'reviews.shareMine': 'Partagez votre avis avec vos proches :',
  'reviews.sort.best': 'Meilleures notes',
  'reviews.sort.worst': 'Notes les plus basses',
  'questions.title': 'Questions & réponses',
  'questions.ask': 'Poser une question',
  'questions.placeholder': 'Ex : Cette pièce est-elle compatible avec la version break ? Faut-il un outil spécifique ?',
  'questions.name': 'Votre nom *',
  'questions.email': 'Votre e-mail * (pour recevoir la réponse)',
  'questions.notice': 'Votre question sera publiée avec notre réponse. ',
  'questions.notifyEmail': 'Vous serez prévenu par e-mail.',
  'questions.emailPrivate': 'Votre e-mail reste privé.',
  'questions.empty': 'Aucune question pour le moment. Une hésitation sur la compatibilité ou le montage ? Posez-nous la question !',
  'questions.yours': 'Votre question',
  'questions.helped': 'Cette réponse vous a aidé ?',
  'gallery.prev': 'Photo précédente',
  'gallery.next': 'Photo suivante',

  // Cart
  'cart.title': { one: 'Votre panier ({n} article)', other: 'Votre panier ({n} articles)' },
  'cart.empty': 'Votre panier est vide',
  'cart.discover': 'Découvrir nos produits',
  'cart.units': 'unités',
  'cart.soldBy': 'Vendu par {n}',
  'cart.proPrice': 'prix pro',
  'cart.quantity': 'quantité',
  'cart.summary': 'Résumé de la commande',
  'cart.promoLogin': "Un code promo ? Connectez-vous pour l'appliquer.",
  "cart.freeShippingLeft": "Plus que {amount} € pour la livraison offerte !",
  'cart.checkout': 'Passer commande',
  'cartDrawer.title': 'Mon panier',
  'cartDrawer.saveLater': 'Garder pour plus tard',
  'cartDrawer.fromWishlist': 'Retrouvez vos envies',
  'cartDrawer.goCart': 'Aller au panier',
  'cartDrawer.checkout': 'Valider le panier',
  'cart.loginToOrder': 'Se connecter pour commander',
  'cart.guestNotice': 'Votre panier sera conservé à la connexion ou à la création de votre compte.',
  "cart.freeShipping120": "Livraison gratuite dès {n} €",
  'cart.return14': 'Retour sous 14 jours',
  'cart.securePayment': 'Paiement 100% sécurisé',
  'promo.placeholder': 'Code promo',
  'promo.invalid': 'Code invalide',
  'promo.remove': 'Retirer le code',
  'savings.title': 'Vous économisez',
  'alt.cheaper': 'Alternative moins chère chez {brand}',
  'alt.perUnit': '−{d} € / unité',
  'alt.total': ', −{s} € au total',
  'alt.replace': 'Remplacer',
  'alt.replaced': '{name} remplacé par {alt}',
  'alt.error': 'Remplacement impossible',

  // Checkout
  'checkout.backToCart': 'Retour au panier',
  'checkout.stepShipping': 'Livraison',
  'checkout.stepPayment': 'Paiement',
  'checkout.stepConfirmation': 'Confirmation',
  'checkout.shippingAddress': 'Adresse de livraison',
  'checkout.savedAddresses': 'Mes adresses enregistrées',
  'checkout.address': 'Adresse',
  'checkout.default': ' · par défaut',
  'checkout.defaultBilling': ' · facturation par défaut',
  'checkout.manageAddresses': 'Gérer mes adresses',
  'checkout.firstName': 'Prénom',
  'checkout.lastName': 'Nom',
  'checkout.email': 'Email',
  'checkout.phone': 'Téléphone',
  'checkout.addressComplement': "Complément d'adresse",
  'checkout.complementPlaceholder': 'Appartement, étage, bâtiment...',
  'checkout.postalCode': 'Code postal',
  'checkout.city': 'Ville',
  'checkout.otherBilling': 'Facturer à une autre adresse',
  'checkout.invoiceFor': '· facture au nom de {company}',
  'checkout.company': 'Société (optionnel)',
  'checkout.vat': 'N° TVA intracom. (optionnel)',
  'checkout.continue': 'Continuer vers le paiement',
  'checkout.paymentMethod': 'Mode de paiement',
  'checkout.autoPayNotice': 'Livraison à {address} (adresse enregistrée).',
  'checkout.autoPayEdit': 'Modifier l\'adresse',
  'checkout.card': 'Carte bancaire',
  'checkout.cardInfo': 'Les informations de carte seront demandées lors de la confirmation.',
  'checkout.ssl': 'Paiement sécurisé SSL',
  'checkout.requested': { one: '{n} demandé', other: '{n} demandés' },
  'checkout.available': { one: '{n} disponible', other: '{n} disponibles' },
  'checkout.fixCart': 'Ajuster mon panier',
  'checkout.country': 'Pays de livraison', 'checkout.carrier': 'Mode de livraison', 'checkout.relay': 'point relais', 'checkout.errCountry': "Nous ne livrons pas encore dans ce pays. Choisissez un autre pays de livraison.", 'cart.shippingEstimate': 'Estimation {country} · {carrier} — le transporteur et le pays se choisissent à l\'étape suivante',
  'checkout.tyreFree': 'Livraison offerte dès 2 pneus', 'checkout.relayPick': 'Choisir mon point relais', 'checkout.relayChange': 'Changer de point relais', 'checkout.relayRequired': 'Veuillez choisir un point relais Mondial Relay sur la carte.', 'checkout.relayTitle': 'Choisissez votre point relais',
  'checkout.weightTier': 'tarif au poids ({w} kg)',
  'checkout.processing': 'Traitement...',
  'checkout.pay': 'Payer {amount} €',
  'checkout.fastDelivery': 'Livraison rapide',
  'checkout.fastDeliverySub': '2-5 jours ouvrés',
  'checkout.securePayment': 'Paiement sécurisé',
  'checkout.sslSub': 'SSL 256-bit',
  'checkout.warranty': 'Garantie',
  'checkout.warrantySub': '2 ans minimum',
  'checkout.summary': 'Récapitulatif',
  'checkout.qty': 'Qté : {n}',
  'checkout.fitting': 'Montage en centre partenaire',
  'checkout.totalHT': 'Total HT (compte pro)',
  'checkout.vatAmount': '· TVA {amount} €',
  'checkout.totalTTC': 'Total TTC',
  'checkout.useWallet': 'Utiliser mon avoir ({amount} € disponibles)',
  'checkout.walletUsed': 'Avoir utilisé',
  'checkout.toPay': 'Reste à payer',
  'checkout.confirmed': 'Commande confirmée !',
  'checkout.thanks': 'Merci pour votre commande. Un email de confirmation a été envoyé à {email}',
  'checkout.orderNumber': 'Numéro de commande',
  'checkout.deliveryTo': 'Livraison à',
  'checkout.viewOrders': 'Voir mes commandes',
  'checkout.errRequired': 'Le champ "{field}" est obligatoire',
  'checkout.errPostal': 'Code postal invalide (5 chiffres attendus)',
  'checkout.errEmail': 'Adresse email invalide',
  'checkout.errPhone': 'Numéro de téléphone invalide (ex: 06 12 34 56 78)',
  'checkout.errBilling': 'Adresse de facturation incomplète (nom ou société, adresse, code postal, ville)',
  'checkout.errOrder': 'Erreur lors de la commande',
  'fitting.title': { one: 'Montage de votre {n} pneu', other: 'Montage de vos {n} pneus' },
  'fitting.intro': 'Optionnel : faites livrer vos pneus dans un centre partenaire qui les montera et équilibrera. Choisissez un créneau dans son calendrier ou laissez le centre vous contacter.',
  'fitting.sorted': ' Centres classés par fiabilité puis par distance depuis {place}.',
  'fitting.none': "Sans montage — livraison à l'adresse indiquée",
  'fitting.recommended': 'Recommandé',
  'fitting.distance': 'à {km} km',
  'fitting.bestRated': 'Le mieux noté près de chez vous',
  'fitting.hideReviews': 'Masquer les avis',
  'fitting.showReviews': 'Voir les avis',
  'fitting.reliable': 'Partenaire fiable',
  'fitting.reliableTitle': 'Centre qui confirme rapidement ses rendez-vous',
  'fitting.online': 'Créneaux en ligne',
  'fitting.perTyre': '/ pneu',
  'fitting.hidden': { one: '{n} centre partenaire à plus de {km} km n\'est pas proposé.', other: '{n} centres partenaires à plus de {km} km ne sont pas proposés.' },
  'fitting.selected': 'Vos pneus seront expédiés chez {name} ({city}). Montage + équilibrage : {total} ajoutés à la commande.',
  'slot.loading': 'Chargement des créneaux…',
  'slot.unavailable': "Ce centre n'a pas encore publié ses créneaux : il vous contactera pour fixer le rendez-vous après la commande.",
  'slot.choose': 'Choisissez votre créneau chez {name}',
  'slot.centreProposes': 'Le centre me proposera une date',
  'slot.info': { one: 'Créneaux de {min} min, au plus tôt {d} jour après la commande (délai de réception des pneus). Le centre confirmera le créneau par e-mail.', other: 'Créneaux de {min} min, au plus tôt {d} jours après la commande (délai de réception des pneus). Le centre confirmera le créneau par e-mail.' },
  'slot.chosen': 'Créneau souhaité : {day} à {time} — à confirmer par le centre.',

  // Home
  'home.h1': "Pièces auto en ligne au meilleur prix — pièces détachées pour toutes les marques",
  'home.h1Sub': "Plus de 6 000 modèles référencés : sélectionnez votre véhicule ou saisissez votre plaque d'immatriculation pour trouver des pièces détachées 100 % compatibles. Grandes marques, livraison 2-5 jours, retour 14 jours.",
  'home.seoTitle': "Pièces auto pas cher en ligne — Pièces détachées toutes marques | OTOPIECES.COM",
  'home.seoDesc': "Pièces détachées auto au meilleur prix sur OTOPIECES.COM : freinage, filtres, moteur, pneus… Recherche par véhicule ou plaque, livraison 2-5 jours, retour 14 j.",
  'home.seoKeywords': "pièces auto, pièces détachées, pièces automobiles pas cher, pièces auto en ligne, recherche par plaque, plaquettes de frein, filtre à huile, pneus",
  'home.faqTitle': "Questions fréquentes sur l'achat de pièces auto en ligne",
  'home.faq1q': "Comment être sûr qu'une pièce est compatible avec ma voiture ?",
  'home.faq1a': "Sélectionnez votre véhicule (marque, modèle, année, motorisation) ou saisissez votre plaque d'immatriculation : le catalogue n'affiche alors que les pièces détachées compatibles, avec un badge « Compatible avec votre véhicule » sur chaque fiche produit.",
  'home.faq2q': "Quels sont les délais et frais de livraison ?",
  'home.faq2a': "Les commandes sont expédiées sous 24 à 48 h et livrées en 2 à 5 jours ouvrés en France (Colissimo, Chronopost ou point relais Mondial Relay). La livraison est offerte à partir d'un certain montant et dès 2 pneus commandés.",
  'home.faq3q': "Puis-je retourner une pièce qui ne convient pas ?",
  'home.faq3a': "Oui, vous disposez de 14 jours après réception pour retourner une pièce neuve, non montée et dans son emballage d'origine. Le remboursement est effectué sous 14 jours après réception du colis.",
  'home.faq4q': "Les pièces sont-elles garanties ?",
  'home.faq4a': "Toutes les pièces détachées vendues sur OTOPIECES.COM sont neuves, issues de grands fabricants (Bosch, Mann-Filter, TRW, Febi…) et bénéficient de la garantie légale de conformité de 2 ans.",
  'home.faq5q': "Quels moyens de paiement acceptez-vous ?",
  'home.faq5a': "Le paiement s'effectue par carte bancaire (Visa, Mastercard, Apple Pay, Google Pay) via la plateforme sécurisée SumUp. Vos données bancaires ne transitent jamais par nos serveurs.",
  'home.faq6q': "Proposez-vous le montage des pièces ou des pneus ?",
  'home.faq6a': "Oui, lors de la commande vous pouvez réserver un créneau de montage dans l'un de nos centres partenaires. Vos pièces y sont livrées directement et montées par un professionnel.",
  'acc.bankSecureNote': "Vos paiements sont traités de manière sécurisée par SumUp. Les cartes enregistrées ici servent uniquement de mémo : seuls les 4 derniers chiffres sont conservés, jamais le numéro complet.",
  'new.menu': "Nouveautés",
  'new.menuHint': "{n} pièce(s) ajoutée(s) cette semaine",
  'new.title': "Nouveautés",
  'new.h1': "Nouveautés : pièces ajoutées ces {d} derniers jours",
  'new.sub': "Les dernières pièces détachées ajoutées au catalogue, triées par date. Sélectionnez votre véhicule pour ne voir que les pièces compatibles.",
  'new.days': "{d} jours",
  'new.onlyVehicle': "Compatibles avec mon véhicule uniquement",
  'new.selectVehicle': "Sélectionnez votre véhicule pour filtrer les nouveautés compatibles",
  'new.allCats': "Toutes les catégories",
  'new.empty': "Aucune nouveauté pour ces critères.",
  'new.showAll': "Afficher toutes les nouveautés",
  'new.seoTitle': "Nouveautés pièces auto — dernières pièces détachées ajoutées",
  'new.seoDesc': "Découvrez les pièces détachées auto ajoutées ces {d} derniers jours sur OTOPIECES.COM : freinage, filtres, moteur… filtrables par véhicule compatible.",
  'new.badge': "Nouveau",
  'new.homeTitle': "Nouveautés de la semaine",
  'new.homeCount': "{n} pièce(s) ajoutée(s) ces 7 derniers jours",
  'new.homeAll': "Toutes les nouveautés",
  'new.subTitleAll': "Recevez les nouveautés de la semaine par e-mail",
  'new.subTitleCat': "Recevez les nouveautés « {name} » par e-mail",
  'new.subHint': "Un seul e-mail le lundi, uniquement s'il y a des nouveautés. Désabonnement en un clic.",
  'new.subButton': "M'abonner",
  'new.subOk': "Abonnement enregistré",
  'new.subAlready': "Vous étiez déjà abonné — abonnement réactivé",
  'new.subError': "Abonnement impossible",
  'new.subDone': "C'est noté ! Les nouveautés ({scope}) seront envoyées chaque lundi à {email}.",
  'new.subManage': "Gérer mes abonnements",
  'new.subRemoved': "Abonnement supprimé",
  'new.subsTitle': "Nouveautés par e-mail",
  'new.subsHint': "Chaque lundi, les pièces ajoutées au catalogue dans les catégories de votre choix.",
  'new.subsEmpty': "Aucun abonnement. Abonnez-vous depuis la page",
  'new.subsSince': "Depuis le {d}",
  'new.subsLast': "dernier envoi {d}",
  'common.loadError': "Le chargement a échoué. Vérifiez votre connexion puis réessayez.",
  'common.retry': "Réessayer",
  'product.movedToCategory': "Ce produit n'est plus disponible — voici la catégorie correspondante.",
  'home.selectVehicle': 'Sélectionnez votre véhicule',
  'home.brand': 'MARQUE',
  'home.model': 'MODÈLE',
  'home.year': 'ANNÉE',
  'home.engine': 'MOTORISATION',
  'home.chooseBrand': 'Choisir une marque',
  'home.chooseModel': 'Choisir un modèle',
  'home.chooseYear': "Choisir l'année",
  'home.chooseEngine': 'Choisir la motorisation',
  'home.search': 'Rechercher...',
  'home.topBrands': 'Marques les plus vendues',
  'home.allBrands': 'Toutes les marques',
  'home.noBrand': 'Aucune marque trouvée',
  'home.noModel': 'Aucun modèle trouvé',
  'home.selectModel': 'Sélectionnez un modèle',
  'home.selectYear': 'Sélectionnez une année',
  'home.noEngine': 'Aucune motorisation disponible',
  'home.selectedVehicle': 'Véhicule sélectionné',
  'home.orPlate': "ou recherchez par plaque d'immatriculation",
  'home.plateLabel': 'Vous connaissez votre plaque ? Recherchez-la dans notre registre',
  'home.searchBtn': 'Rechercher',
  'home.plateRequired': "Saisissez votre numéro d'immatriculation",
  'home.plateNotFound': 'Véhicule introuvable pour cette plaque',
  'home.identified': 'Véhicule identifié :',
  'home.simulated': '(identification simulée)',
  'home.seeParts': 'Voir les pièces compatibles',
  'home.allVehicleBrands': 'Toutes les marques de véhicules',
  'home.notFoundCar': 'Vous ne trouvez pas votre voiture dans le catalogue ?',
  'home.categoriesTitle': 'Trouvez des pièces détachées dans le catalogue OTOPIECES.COM',
  'home.moreParts': 'Plus de pièces détachées',
  'home.accessoriesTitle': 'Essentiels pour la voiture : accessoires, produits de nettoyage et outils',
  'home.allSubcategories': 'Toutes les sous-catégories ({n})',
  'home.trust.return': 'Retour sous 14 jours',
  'home.trust.returnSub': 'Satisfait ou remboursé',
  'home.trust.payments': 'Paiements sécurisés',
  'home.trust.app': 'Une appli bien pratique',
  'home.trust.appSub': 'pour acheter des pièces automobiles',
  'home.trust.videos': 'Vidéos de réparation',
  'home.trust.videosSub': 'Guides vidéo',
  'home.bestsellers': "Les best-sellers d'OTOPIECES.COM : acheter des pièces détachées à prix avantageux",
  'home.compatibleParts': 'Pièces compatibles avec votre {vehicle}',
  'home.compatibleCount': '{n} pièces compatibles',
  'home.seeAllCompatible': 'Voir toutes les pièces compatibles',
  'home.addedToCart': 'Produit ajouté au panier !',
  'home.addError': "Erreur lors de l'ajout au panier",
  'home.carBrands': 'Pièces auto pour marques de voiture les plus demandées',
  'home.topModels': 'Les modèles de véhicules les plus consultés',
  'home.topModelsAll': 'Toutes les marques',
  'home.topModelsParts': 'Pièces compatibles',
  'home.recentVehicles': 'Vos derniers véhicules',
  'home.recentClear': 'Effacer',
  'garage.compareTitle': 'Comparer les pièces compatibles',
  'garage.compareButton': 'Comparer',
  'garage.compareThird': '+ 3e véhicule (optionnel)',
  'garage.budgetTitle': 'Budget entretien annuel estimé',
  'garage.budgetHint': "Estimation à partir des pièces compatibles du catalogue (pièces d'usure × fréquence de remplacement habituelle). Prix médian, ou « éco » = pièce la moins chère.",
  'garage.budgetPerYear': ' / an',
  'garage.dropBadge': 'Budget en baisse de {amount}/an depuis le {date}',
  'garage.historyTitle': 'Évolution du budget sur 12 mois',
  'garage.historyMedian': 'Budget estimé',
  'garage.historyEco': 'Budget éco',
  'garage.historyEmpty': 'L\'historique démarre aujourd\'hui : un point est enregistré chaque jour, la courbe se dessinera au fil des semaines.',
  'garage.historyChange': 'Variation sur la période',
  'garage.historyAlert': 'Alerte baisse envoyée',
  'garage.historyRange': 'Min {min} · Max {max}',
  'garage.budgetEco': 'Éco :',
  'garage.budgetEcoTotal': 'Budget éco :',
  'garage.budgetCoverage': '{n} poste(s) estimé(s) sur {total}',
  'garage.budgetNoParts': "Aucune pièce d'entretien compatible référencée pour ce véhicule pour l'instant.",
  'garage.budgetPost': 'Poste',
  'garage.budgetInterval': 'Fréquence',
  'garage.budgetEstimated': 'Prix médian',
  'garage.budgetPerYearCol': 'Par an',
  'garage.budgetParts': 'pièce(s) compatible(s)',
  'garage.budgetEvery': 'tous les {n} an(s)',
  'garage.budgetMissing': 'Non estimés (pas encore de pièce compatible) :',
  'garage.budgetSeeParts': 'Voir toutes les pièces compatibles →',
  'garage.budgetUpcoming': 'À prévoir 12 mois :',
  'garage.logCol': "Carnet d'entretien",
  'garage.logReplaced': 'Remplacé le…',
  'garage.logNext': 'À jour · prochain : {d}',
  'garage.logOverdue': 'Échéance dépassée',
  'garage.logEdit': 'modifier',
  'garage.logClear': 'Effacer',
  'garage.logSaved': "Carnet d'entretien mis à jour",
  'garage.logError': 'Enregistrement impossible',
  'garage.logTracked': '{n} poste(s) suivi(s)',
  'garage.logHint': 'Indiquez la date (et le kilométrage) du dernier remplacement : la prochaine échéance est la plus proche entre date + fréquence et km + intervalle (converti avec votre kilométrage annuel). Le poste sort du budget « à prévoir 12 mois » jusque-là ; le budget annuel lissé reste inchangé.',
  'garage.logKm': 'km au remplacement',
  'garage.logKmCurrent': 'km actuel du véhicule',
  'garage.logKmAt': 'à {km}',
  'garage.logOrKm': 'ou {km}',
  'garage.logMileage': "≈ {km} aujourd'hui",
  'garage.logFromOrder': 'acheté sur OTOPIECES ({d})',
  'garage.carnetPdf': 'Télécharger le carnet (PDF)',
  'garage.carnetPdfDone': "Carnet d'entretien téléchargé",
  'garage.carnetEmail': 'Recevoir mon carnet par e-mail',
  'garage.carnetEmailDone': 'Carnet d\'entretien envoyé à {email}',
  'home.seeBrands': 'Voir les {n} marques',
  'home.partsFor': 'Pièces auto {brand}',
  'home.models': '{n} modèles',
  'home.manufacturers': 'Offres exceptionnelles sur les pièces détachées automobiles des plus grands fabricants',
  'home.articles': "Tous pour votre voiture : guides et conseils d'experts",
  'home.learnMore': 'En savoir plus',
  'home.aboutTitle': "Pièces détachées auto en ligne : tout pour l'entretien et la réparation de votre voiture",
  'home.about1a': "OTOPIECES.COM est votre boutique en ligne de ",
  'home.about1b': "pièces détachées auto pas cher",
  'home.about1c': " : freinage (disques, plaquettes, étriers), filtration (filtre à huile, à air, d'habitacle, à carburant), moteur, suspension, direction, éclairage, échappement, pneus et jantes. Que vous soyez particulier, passionné de mécanique ou garagiste, vous trouvez ici la pièce adaptée à votre véhicule au meilleur prix.",
  'home.about2a': "Chaque référence est contrôlée pour la ",
  'home.about2b': "compatibilité avec votre voiture",
  'home.about2c': " : sélectionnez la marque, le modèle, l'année et la motorisation, ou saisissez simplement votre plaque d'immatriculation. Le catalogue n'affiche alors que les pièces compatibles, avec leurs références d'origine (OE) et leurs équivalences entre fabricants pour comparer et choisir en toute confiance.",
  'home.about3': "Nous ne proposons que des pièces neuves issues des grands équipementiers (Bosch, Mann-Filter, TRW, Febi, Valeo…), couvertes par la garantie légale de 2 ans. Une question sur le choix d'une pièce, sa pose ou sa compatibilité ? Notre service client, composé de spécialistes de la pièce auto, vous répond rapidement par chat, e-mail ou téléphone.",
  'home.about4a': "Commandez vos pièces auto en quelques clics avec un ",
  'home.about4b': "paiement sécurisé, une livraison en 2 à 5 jours",
  'home.about4c': " en France et en Europe (domicile ou point relais), un retour possible sous 14 jours et la possibilité de réserver le montage dans un centre partenaire. OTOPIECES.COM : la pièce détachée au juste prix, pour tous les modèles de véhicules.",
  'reviews.errRating': 'Choisissez une note de 1 à 5 étoiles',
  'reviews.errShort': 'Votre commentaire est trop court (10 caractères minimum)',
  'reviews.errSend': "Erreur lors de l'envoi de votre avis",
  'reviews.verifiedCount': { one: '{n} avis vérifié', other: '{n} avis vérifiés' },
  'reviews.withPhotos': { one: '{n} avec photo', other: '{n} avec photos' },
  'reviews.notAllowed': 'Seuls les clients ayant commandé ce produit peuvent laisser un avis.',
  'reviews.yourReviewOn': 'Votre avis sur {name}',
  'reviews.invite': 'Merci de prendre le temps de partager votre expérience sur cette pièce.',
  'reviews.rewardTitle': 'Donnez votre avis, recevez -{percent} % sur votre prochaine commande',
  'reviews.rewardText': 'Réservé aux clients ayant acheté ce produit. Votre code personnel vous est remis dès la publication de l\'avis (valable {days} jours).',
  'reviews.rewardLogin': 'Je me connecte pour donner mon avis',
  'reviews.rewardWrite': 'Donner mon avis',
  'reviews.rewardAfterPurchase': 'Disponible après l\'achat de ce produit.',
  'reviews.rewardThanks': 'Merci pour votre avis ! Voici votre code -{percent} %',
  'reviews.rewardCopy': 'Copier',
  'reviews.rewardCopied': 'Code copié',
  'reviews.rewardValidity': 'À saisir dans le panier · valable jusqu\'au {date}, usage unique.',
  'reviews.rewardUsed': 'Code déjà utilisé — merci !',
  'reviews.rewardMinOrder': 'dès {amount} € d\'achat',
  'reviews.customerPhotos': 'Photos de nos clients ({n})',
  'reviews.customerPhotosSee': 'Voir les avis',
  'reviews.customerPhotosHint': 'Photos réelles envoyées par des acheteurs vérifiés avec leur avis. Cliquez pour agrandir.',
  'reviews.submit': 'Publier mon avis',
  'reviews.reported': 'Merci, notre équipe va vérifier cet avis.',
  'questions.voteError': 'Vote impossible',
  'questions.pending': 'En attente de réponse — visible uniquement par vous',
  'questions.errShort': 'Votre question est trop courte (10 caractères minimum)',
  'questions.errName': 'Indiquez votre nom',
  'questions.errEmail': 'Indiquez un e-mail valide pour recevoir la réponse',
  'questions.yourQuestionOn': 'Votre question sur {name}',
  'questions.send': 'Envoyer ma question',
  'tyre.summer': 'Pneu été', 'tyre.winter': 'Pneu hiver', 'tyre.allSeason': 'Pneu 4 saisons', 'tyre.car': 'Voiture', 'tyre.van': 'Utilitaire',
  'tyre.size': 'Dimension', 'tyre.indexes': 'Indices charge / vitesse', 'tyre.season': 'Saison', 'tyre.vehicleType': 'Type de véhicule', 'tyre.euLabel': 'Étiquette UE',
  'tyre.fuel': 'Consommation', 'tyre.wet': 'Adhérence', 'tyre.specifics': 'Spécificités', 'tyre.xlSpec': 'XL (renforcé)', 'tyre.pcd': 'Entraxe', 'tyre.offset': 'Déport (ET)',
  'tyre.centerBore': 'Alésage central', 'tyre.material': 'Matière', 'tyre.steel': 'Acier (tôle)', 'tyre.aluminium': 'Aluminium', 'tyre.finish': 'Finition',
  'tyre.steelWheel': 'Jante tôle', 'tyre.aluWheel': 'Jante aluminium', 'tyre.snowflake': '3PMSF · homologué Loi Montagne', 'tyre.xl': 'XL renforcé',
  'tyre.euLabelView': 'Étiquette complète & PDF', 'tyre.euLabelFull': 'Étiquette européenne', 'tyre.fuelFull': 'Efficacité en carburant', 'tyre.noiseFull': 'Bruit de roulement externe', 'tyre.snowGrip': 'Adhérence sur neige (3PMSF)', 'tyre.noSnowMark': 'Sans marquage neige / verglas', 'tyre.labelDisclaimer': "Document informatif établi à partir des données fournisseur ; l'étiquette officielle est celle du fabricant.",
  'tyre.euLabelLine1': 'Étiquette', 'tyre.euLabelLine2': 'européenne', 'tyre.fuelHint': 'Efficacité énergétique (A = meilleure)', 'tyre.wetGrip': 'Adhérence sol mouillé',
  'tyre.wetHint': 'Freinage sur sol mouillé (A = meilleure)', 'tyre.noiseTitle': 'Bruit de roulement externe', 'tyre.noiseClass': 'Bruit · classe {c}',
  "acc.dashboard": "Mon OTOPIECES",
  "acc.garage": "Mon garage",
  "acc.maintenance": "Carnet d'entretien",
  "acc.maintenanceTitle": "Carnet d'entretien prédictif",
  "acc.sellerListings": "Mes annonces d'occasion",
  "acc.sellerImport": "Importer mon catalogue",
  "acc.sellerFeeds": "Synchronisation de mon catalogue",
  "acc.sellerOrders": "Mes commandes d'occasion",
  "acc.seller": "Devenir vendeur",
  "acc.pro": "Compte professionnel",
  "acc.orders": "Mes commandes",
  "acc.wishlist": "Ma liste de souhaits",
  "acc.addresses": "Mon carnet d'adresses",
  "acc.bank": "Coordonnées bancaires",
  "acc.wallet": "Mon compte de dépôt",
  "acc.settings": "Paramètres",
  "acc.compare": "Comparaison",
  "acc.logout": "Se déconnecter",
  "acc.proValidated": "Compte professionnel validé",
  "acc.myAccount": "Mon compte",
  "acc.proBannerOk": "Compte professionnel validé — {company}",
  "acc.proBannerPending": "Demande de compte professionnel en cours de validation ({company})",
  "acc.proBannerRefused": "Votre demande de compte professionnel a été refusée",
  "acc.details": "Détails",
  "acc.openOrders": "{n} en cours · {spent} dépensés",
  "acc.spent": "{spent} dépensés",
  "acc.walletCard": "Compte de dépôt",
  "acc.walletHint": "Avoir utilisable au paiement",
  "acc.wishlistCard": "Liste de souhaits",
  "acc.wishlistHint": "pièces suivies",
  "acc.vehiclesHint": "véhicule(s) enregistré(s)",
  "acc.addressesCard": "Carnet d'adresses",
  "acc.addressesHint": "adresse(s)",
  "acc.cards": "{n} carte(s)",
  "acc.ibanYes": "IBAN enregistré",
  "acc.ibanNo": "Aucun IBAN",
  "acc.lastOrder": "Dernière commande",
  "acc.viewOrders": "Voir mes commandes",
  "acc.proCta": "Vous êtes un professionnel de l'automobile ?",
  "acc.proCtaSub": "Demandez votre compte professionnel : prix HT, factures au nom de votre société, badge Pro.",
  "acc.personalInfo": "Informations personnelles",
  "acc.savedAddress": "Adresse de livraison enregistrée",
  "acc.password": "Mot de passe",
  "acc.prefs": "Préférences d'affichage & notifications",
  "acc.language": "Langue",
  "acc.currency": "Devise",
  "acc.orderEmails": "E-mails de suivi de commande (confirmation, expédition)",
  "acc.marketing": "Offres et promotions personnalisées",
  "acc.delete": "Supprimer mon compte",
  "acc.deleteInfo": "Vos adresses, véhicules, listes et cartes seront effacés. Vos factures restent disponibles auprès de notre service client.",
  "acc.deleteConfirm": "Supprimer définitivement",
  "acc.currentPwd": "Mot de passe actuel *",
  "acc.newPwd": "Nouveau mot de passe * (8 caractères min.)",
  "acc.confirmPwd": "Confirmer le nouveau mot de passe *",
  "acc.showPwd": "Afficher",
  "acc.hidePwd": "Masquer",
  "acc.pwdWord": "les mots de passe",
  "acc.docLang": "Langue des documents (factures, e-mails)",
  "acc.defaultShipping": "Adresse de livraison par défaut",
  "acc.defaultBilling": "Adresse de facturation par défaut",
  "acc.addressesInfo": "Vos adresses sont proposées au moment de la commande. L'adresse de livraison par défaut est pré-remplie automatiquement.",
  "acc.bankAccount": "Compte bancaire (remboursements)",
  "acc.bankInfo": "Utilisé uniquement pour vous rembourser en cas de retour ou d'annulation.",
  "acc.saveIban": "Enregistrer l'IBAN",
  "acc.cardsInfo": "Pour commander plus vite. Le numéro complet n'est jamais conservé.",
  "acc.default": "Par défaut",
  "acc.remove": "Supprimer",
  "acc.save": "Enregistrer",
  "acc.history": "Historique des mouvements",
  "acc.proInfo": "Garages, carrossiers, revendeurs : bénéficiez de l'affichage des prix HT, d'une facturation avec votre n° de TVA et d'un badge Pro.",
  "acc.editInfo": "Modifier les informations",
  "acc.withdraw": "Retirer ma demande",
  "acc.companyName": "Raison sociale *",
  "acc.siret": "SIRET * (14 chiffres)",
  "acc.vatNumber": "N° TVA intracommunautaire",
  "acc.sector": "Secteur d'activité *",
  "acc.companyPhone": "Téléphone société",
  "acc.proof": "Justificatif (lien Kbis / URL) — optionnel",
  "orders.loginPrompt": "Connectez-vous pour voir vos commandes",
  "orders.login": "Se connecter",
  "orders.empty": "Vous n'avez pas encore passé de commande",
  "orders.order": "Commande {n}",
  "orders.vehicle": "Véhicule",
  "orders.reorderVehicle": "Racheter pour ma voiture",
  "orders.reorderOk": "{n} article(s) remis au panier",
  "orders.reorderPartial": "{n} article(s) remis au panier · {s} indisponible(s)",
  "orders.reorderNone": "Aucun article de cette commande n'est disponible actuellement.",
  "orders.filterVehicle": "Filtrer par véhicule",
  "orders.filterAll": "Toutes",
  "orders.filterNoVehicle": "Sans véhicule",
  "orders.filterEmpty": "Aucune commande pour ce véhicule.",
  "orders.cancelHint": "Vous avez changé d'avis ? Vous pouvez annuler tant que la commande n'est pas en préparation.",
  "orders.cancel": "Annuler ma commande",
  "orders.cancelled": "Cette commande a été annulée.",
  "orders.refunded": "Cette commande a été remboursée.",
  "orders.tracking": "Suivi de colis — {carrier}",
  "orders.track": "Suivre mon colis",
  "orders.review": "Laisser un avis",
  "orders.walletUsed": "Avoir utilisé (compte de dépôt)",
  "orders.paid": "réglé {amount} €",
  "orders.fittingAt": "Montage chez {name}",
  "orders.fitTyres": { one: "{n} pneu", other: "{n} pneus" },
  "orders.fitRequested": "Créneau souhaité : {d} — en attente de confirmation par le centre.",
  "orders.fitConfirmed": "Rendez-vous confirmé : {d}",
  "orders.fitContact": "Le centre vous contactera pour fixer le rendez-vous{p}.",
  "orders.fitReview": "Noter ce centre de montage",
  "orders.fitRating": "Votre note du centre : {r}/5 — merci !",
  "appt.locked": "Rendez-vous dans moins de {h} h : pour le modifier, contactez le centre{p}.",
  "appt.actionFailed": "Action impossible",
  "appt.moved": "Rendez-vous déplacé — le centre doit confirmer le nouveau créneau",
  "appt.requested": "Créneau demandé — le centre doit le confirmer",
  "appt.confirmCancel": "Annuler ce rendez-vous ? Le montage reste prévu, le centre vous proposera une autre date.",
  "appt.cancelled": "Rendez-vous annulé — le centre a été prévenu",
  "appt.confirmCancelService": "Annuler définitivement le montage chez {name} ?\n\nLe montant du montage ({a} €) vous sera remboursé sous forme d'avoir sur votre compte de dépôt et un avoir PDF sera généré. Vos pneus restent commandés.",
  "appt.serviceCancelled": "Montage annulé — avoir de {a} € crédité sur votre compte de dépôt",
  "appt.move": "Déplacer le rendez-vous",
  "appt.pick": "Choisir un créneau",
  "appt.cancelSlot": "Annuler le créneau",
  "appt.cancelService": "Annuler le montage (avoir)",
  "appt.newSlot": "Nouveau créneau chez {name}",
  "appt.loadingCal": "Chargement du calendrier…",
  "appt.noCalendar": "Ce centre n'a pas de calendrier en ligne : indiquez la date souhaitée (au moins {h} h à l'avance), le centre confirmera.",
  "appt.request": "Demander ce créneau",
  "appt.centreConfirms": "Le centre reçoit un e-mail et confirme le créneau.",
  "appt.changes": { one: "{n} modification de rendez-vous — dernière : {last}", other: "{n} modifications de rendez-vous — dernière : {last}" },
  "appt.chCancelled": "annulation",
  "appt.chReassigned": "réaffectation vers {c}",
  "appt.chMoved": "déplacement vers {d}",
  "orders.cancelledToast": "Commande annulée. Les articles ont été remis en stock.",
  "orders.cancelError": "Impossible d'annuler cette commande",
  "status.En attente": "En attente",
  "status.En cours": "En cours",
  "status.Expédié": "Expédié",
  "status.Livré": "Livré",
  "status.Annulée": "Annulée",
  "status.Remboursée": "Remboursée",
  "cat.products": "Produits",
  "cat.found": { one: "{n} produit trouvé", other: "{n} produits trouvés" },
  "cat.filterBy": "Filtrer par",
  "cat.brand": "Marque",
  "cat.noBrand": "Aucune marque",
  "cat.price": "Prix (€)",
  "cat.noneFilters": "Aucun produit ne correspond à vos filtres",
  "cat.noneVehicle": "Aucune pièce compatible avec votre véhicule dans cette catégorie",
  "cat.none": "Aucun produit trouvé dans cette catégorie",
  "cat.related": "Recherches associées",
  "cat.filters": "Filtres",
  "search.filterCategory": "Catégorie",
  "search.noneWithFilters": "Aucun résultat avec ces filtres.",
  "cat.sortRelevance": "Pertinence",
  "cat.sortPriceAsc": "Prix croissant",
  "cat.sortPriceDesc": "Prix décroissant",
  "cat.sortRating": "Meilleures notes",
  "cat.sortDiscount": "Meilleures remises",
  "cat.sortNewest": "Nouveautés",
  "cat.bestPriceTitle": "N'afficher que les produits pour lesquels OTOPIECES est moins cher que tous les concurrents suivis",
  "cat.sortBy": "Trier par",
  "cat.collapse": "Réduire",
  "cat.moreSubs": "Voir les {n} autres sous-catégories",
  "cat.yourVehicle": "Votre véhicule",
  "cat.onlyCompatible": "Voir uniquement les pièces compatibles",
  "cat.allParts": "Voir toutes les pièces",
  "cat.change": "Changer",
  "acc.newsletter": "Recevoir les offres et la newsletter OTOPIECES.COM",
  "acc.changePwd": "Changer le mot de passe",
  "acc.deleteOpen": "Je souhaite supprimer mon compte",
  "acc.confirmYourPwd": "Confirmez votre mot de passe",
  "acc.addrLabel": "Libellé (Maison, Atelier…)",
  "acc.addrLabelPh": "Maison",
  "acc.myAddresses": "Mes adresses ({n}/10)",
  "acc.addAddress": "Ajouter une adresse",
  "acc.noAddress": "Aucune adresse enregistrée pour l'instant.",
  "acc.shipDefault": "Livraison par défaut",
  "acc.setShipping": "Définir pour la livraison",
  "acc.billDefault": "Facturation par défaut",
  "acc.setBilling": "Définir pour la facturation",
  "acc.holder": "Titulaire *",
  "acc.savedCards": "Cartes enregistrées ({n}/5)",
  "acc.addCard": "Ajouter une carte",
  "acc.noCard": "Aucune carte enregistrée.",
  "acc.month": "Mois *",
  "acc.year": "Année *",
  "acc.txCredit": "Avoir crédité",
  "acc.txDebit": "Débit",
  "acc.txOrder": "Utilisé sur commande",
  "acc.txRefund": "Remboursement en avoir",
  "acc.balance": "Solde disponible",
  "acc.walletUsage": "Utilisable automatiquement au moment du paiement (case « Utiliser mon avoir »).",
  "acc.noTx": "Aucun mouvement pour l'instant.",
  "acc.proPending": "Demande en cours de validation",
  "acc.proRefused": "Demande refusée",
  "acc.resend": "Renvoyer la demande",
  "acc.requestPro": "Demander un compte professionnel",
  "cat.showResults": "Voir {n} produit(s)",
  "tw.searchTyres": "Rechercher des pneus",
  "tw.tyres": "Pneus",
  "tw.searchWheels": "Rechercher des jantes",
  "tw.wheels": "Jantes",
  "tw.byVehicle": "Par véhicule",
  "tw.vehicle": "Véhicule",
  "tw.title": "Pneus, jantes et accessoires",
  "tw.counts": "{t} pneus, {w} jantes",
  "tw.defaultTitle": "Pneus et jantes",
  "tw.metaTitle": "Pneus et jantes auto — recherche par dimension ou par véhicule",
  "tw.metaDesc": "Trouvez vos pneus été, hiver, 4 saisons par dimension (205/55 R16) ou par véhicule (dimensions d'origine), et vos jantes alu ou tôle par entraxe, déport et alésage.",
  "tw.intro": "Recherchez vos pneus par dimension exacte (largeur, hauteur, diamètre, indices), par véhicule (dimensions d'origine constructeur) ou vos jantes par entraxe, déport et alésage. Marques premium et budget, livraison rapide, montage possible en centre partenaire.",
  "tw.oeSubtitle": "Dimensions d'origine pour {label}",
  "tw.accessoriesTitle": "Accessoires pneus & roues",
  "tw.accessoriesSub": "Boulons, antivols, capteurs TPMS, chaînes neige, crics et tout l'équipement autour de la roue.",
  "tw.articles": { one: "{n} article", other: "{n} articles" },
  "tw.comingSoon": "Bientôt disponible",
  "tw.popularSizes": "Dimensions les plus courantes",
  "tw.allSeasons": "Pneus pour toutes les saisons",
  "tw.brands": "Marques de pneus et jantes",
  "tw.guideTitle": "{k} : le guide OTOPIECES",
  "tw.about": "À propos : {n}",
  "tw.faqTitle": "Questions fréquentes : {n}",
  "tw.summer": "Été",
  "tw.winter": "Hiver",
  "tw.fourSeasons": "4 saisons",
  "tw.vt.voiture": "Voiture",
  "tw.vt.suv": "4x4 / SUV",
  "tw.vt.utilitaire": "Utilitaire",
  "tw.vt.4x4": "4x4",
  "tw.quickSearch": "Recherche rapide par dimension",
  "tw.quickSearchEx": "— ex. 205 / 55 R16 91V",
  "tw.howToRead": "Comment lire mon pneu ?",
  "tw.width": "Largeur",
  "tw.height": "Hauteur",
  "tw.diameter": "Diamètre",
  "tw.loadIndex": "Indice de charge",
  "tw.speedIndex": "Indice de vitesse",
  "tw.widthPh": "Largeur (ex. 205)",
  "tw.heightPh": "Hauteur (ex. 55)",
  "tw.diameterPh": "Diamètre (ex. R16)",
  "tw.season": "Saison",
  "tw.advanced": "Sélectionner par paramètres",
  "tw.brand": "Marque",
  "tw.model": "Modèle",
  "tw.allBrands": "Toutes les marques",
  "tw.modelPh": "ex. Primacy, CrossClimate…",
  "tw.homologation": "Homologation (ex. MO, *, AO)",
  "tw.optional": "Optionnel",
  "tw.priceMin": "Prix minimum (€)",
  "tw.priceMax": "Prix maximum (€)",
  "tw.priceMinShort": "Prix min (€)",
  "tw.priceMaxShort": "Prix max (€)",
  "tw.runflat": "Roulage à plat (RunFlat)",
  "tw.runflatHint": "Permet de rouler ~80 km à 80 km/h après une crevaison",
  "tw.xl": "Renforcé (XL)",
  "tw.xlHint": "Capacité de charge accrue",
  "tw.ms": "Boue / neige (M+S)",
  "tw.snowflake": "Adhérence neige (3PMSF)",
  "tw.studded": "Cloutés",
  "tw.reset": "Réinitialiser les filtres",
  "tw.tyresInCatalog": "{n} pneus au catalogue",
  "tw.wheelsInCatalog": "{n} jantes au catalogue",
  "tw.wheelSpecs": "Caractéristiques de la jante",
  "tw.wheelSpecsEx": "— ex. 7J x 17 — 5x112 — ET45 — Alésage 66,6 mm",
  "tw.widthJ": "Largeur (J)",
  "tw.widthJPh": "Largeur (ex. 7J)",
  "tw.diameterInPh": "Diamètre (ex. 17\")",
  "tw.holes": "Nb de trous",
  "tw.holesPh": "Trous (ex. 5)",
  "tw.pcd": "Entraxe (PCD)",
  "tw.pcdPh": "PCD (ex. 112)",
  "tw.et": "Déport (ET)",
  "tw.etPh": "Déport (ex. ET45)",
  "tw.centerBore": "Alésage central",
  "tw.centerBorePh": "Alésage (ex. 66,6)",
  "tw.material": "Matière",
  "tw.type": "Type",
  "tw.color": "Couleur / finition",
  "tw.allF": "Toutes",
  "tw.allM": "Tous",
  "tw.wheelModelPh": "ex. TZ, Ultraleggera…",
  "tw.mat.aluminium": "Aluminium",
  "tw.mat.acier": "Acier",
  "tw.type.alu": "Jante aluminium",
  "tw.type.tole": "Jante tôle",
  "tw.type.ete": "Jante été",
  "tw.type.hiver": "Jante hiver",
  "tw.outOfStock": "Rupture de stock",
  "tw.leadDays": "Sous {n} j",
  "tw.inStock": "En stock · expédié sous 24 h",
  "tw.pcdShort": "Entraxe",
  "tw.offset": "Déport",
  "tw.bore": "Alésage",
  "tw.finish": "Finition",
  "tw.perUnit": "l'unité · {p} € les 4",
  "tw.viewProduct": "Voir le produit",
  "tw.tyresFound": { one: "{n} pneu trouvé", other: "{n} pneus trouvés" },
  "tw.wheelsFound": { one: "{n} jante trouvée", other: "{n} jantes trouvées" },
  "tw.sortPriceAsc": "Prix croissant",
  "tw.sortPriceDesc": "Prix décroissant",
  "tw.sortRating": "Meilleures notes",
  "tw.sortBrand": "Marque A→Z",
  "tw.noResults": "Aucun résultat pour ces critères",
  "tw.noResultsHint": "Élargissez la recherche : retirez un indice ou une option.",
  "tw.eu.title": "Étiquette UE",
  "tw.eu.fuel": "Carburant",
  "tw.eu.wet": "Sol mouillé",
  "tw.eu.noise": "Bruit",
  "tw.eu.onlyA": "A uniquement",
  "tw.eu.aTo": "A à {g}",
  "tw.eu.noiseA": "≤ 68 dB (classe A)",
  "tw.eu.noiseB": "≤ 71 dB (classe B)",
  "tw.eu.noise75": "≤ 75 dB",
  "tw.eu.snowflake": "3PMSF (Loi Montagne)",
  "tw.vs.pickAtLeast": "Choisissez au moins une marque et un modèle",
  "tw.vs.notFound": "Véhicule introuvable",
  "tw.vs.select": "Sélectionnez votre véhicule",
  "tw.vs.selectSub": "— nous affichons les dimensions de pneus et jantes montées d'origine",
  "tw.vs.showOE": "Voir les dimensions d'origine",
  "tw.vs.reset": "Réinitialiser",
  "tw.vs.searching": "Recherche des montes constructeur pour {v}… (jusqu'à 30 s la première fois)",
  "tw.vf.tyresAvail": { one: "{n} pneu disponible", other: "{n} pneus disponibles" },
  "tw.vf.wheelsAvail": { one: "{n} jante disponible", other: "{n} jantes disponibles" },
  "tw.vf.none": "Aucun article pour l'instant",
  "tw.vf.notFound": "Dimensions d'origine non renseignées pour {v}",
  "tw.vf.notFoundHint": "Relevez la dimension inscrite sur le flanc de votre pneu (ex. 205/55 R16 91V) et utilisez la recherche par dimension.",
  "tw.vf.switch": "Rechercher par dimension →",
  "tw.vf.oeFor": "Dimensions d'origine constructeur pour",
  "tw.vf.aiNotice": "Dimensions établies automatiquement à partir des données constructeur et en attente de vérification par notre équipe. Avant de commander, confirmez la dimension inscrite sur le flanc de votre pneu actuel.",
  "tw.vf.oeTyres": "Pneus d'origine",
  "tw.vf.oeWheels": "Jantes d'origine",
  "tw.vf.thread": "Filetage",
  "tw.vf.diameters": "Diamètres",
  "tw.vf.seeTyres": "Voir les pneus compatibles",
  "tw.vf.seeWheels": "Voir les jantes compatibles",
  "tw.vf.in": "en {s}",
  "tw.vc.year": "Année",
  "tw.vc.engine": "Motorisation",
  "tw.vc.pickBrand": "Choisir une marque",
  "tw.vc.pickModel": "Choisir un modèle",
  "tw.vc.selBrand": "Sélectionnez une marque",
  "tw.vc.pickYear": "Choisir l'année",
  "tw.vc.selModel": "Sélectionnez un modèle",
  "tw.vc.allEngines": "Toutes les motorisations",
  "tw.vc.selYear": "Sélectionnez l'année",
  "tw.vc.hp": "ch",
  "tw.sg.title": "Comment lire la dimension de vos pneus ?",
  "tw.sg.sub": "Tout est inscrit sur le flanc du pneu. Survolez ou touchez chaque élément de l'exemple",
  "tw.sg.width": "Largeur",
  "tw.sg.widthDesc": "Largeur du pneu en millimètres, mesurée d'un flanc à l'autre (ici 205 mm).",
  "tw.sg.height": "Hauteur (série)",
  "tw.sg.heightDesc": "Hauteur du flanc en % de la largeur : 55 % de 205 mm ≈ 113 mm. Plus le chiffre est petit, plus le pneu est « taille basse ».",
  "tw.sg.radial": "Structure",
  "tw.sg.radialDesc": "R = structure radiale, la norme sur toutes les voitures modernes.",
  "tw.sg.diameter": "Diamètre de jante",
  "tw.sg.diameterDesc": "Diamètre intérieur du pneu = diamètre de votre jante, en pouces (16\" ≈ 40,6 cm).",
  "tw.sg.load": "Indice de charge",
  "tw.sg.loadDesc": "Charge maximale par pneu : 91 = 615 kg. Ne descendez jamais sous l'indice préconisé par le constructeur.",
  "tw.sg.speed": "Indice de vitesse",
  "tw.sg.speedDesc": "Vitesse maximale autorisée : T 190 km/h · H 210 · V 240 · W 270 · Y 300. Un pneu hiver peut avoir un indice inférieur (mini H en France si ≥ vitesse max du véhicule − 1 catégorie).",
  "tw.sg.where": "Où trouver l'info ?",
  "tw.sg.whereText": "Sur le flanc du pneu actuel, sur l'étiquette dans l'ouverture de la portière conducteur, dans la trappe à carburant ou le carnet d'entretien. Vous pouvez aussi utiliser l'onglet",
  "tw.sg.whereEnd": "pour retrouver les dimensions d'origine.",
  "auth.loginTitle": "Connexion",
  "auth.loginSub": "Accédez à votre compte OTOPIECES.COM",
  "auth.sessionExpired": "Votre session a expiré. Veuillez vous reconnecter.",
  "auth.email": "Email",
  "auth.password": "Mot de passe",
  "auth.emailPh": "votre@email.com",
  "auth.passwordPh": "Votre mot de passe",
  "auth.remember": "Rester connecté",
  "auth.rememberDays": "(30 jours)",
  "auth.forgot": "Mot de passe oublié ?",
  "auth.loggingIn": "Connexion...",
  "auth.login": "Se connecter",
  "auth.noAccount": "Pas encore de compte ?",
  "auth.createAccount": "Créer un compte",
  "auth.emailRequired": "Email requis",
  "auth.passwordRequired": "Mot de passe requis",
  "auth.badCredentials": "Email ou mot de passe incorrect",
  "auth.registerSub": "Créez votre compte pour suivre vos commandes et enregistrer vos véhicules",
  "auth.firstName": "Prénom",
  "auth.lastName": "Nom",
  "auth.firstNamePh": "Jean",
  "auth.lastNamePh": "Dupont",
  "auth.emailPh2": "jean.dupont@email.com",
  "auth.phone": "Téléphone (optionnel)",
  "auth.phonePh": "06 12 34 56 78",
  "auth.min8": "Minimum 8 caractères",
  "auth.confirmPassword": "Confirmer le mot de passe",
  "auth.repeatPh": "Répétez le mot de passe",
  "auth.acceptPrefix": "J'accepte les",
  "auth.terms": "conditions générales",
  "auth.and": "et la",
  "auth.privacy": "politique de confidentialité",
  "auth.newsletter": "Je souhaite recevoir les offres et promotions par email",
  "auth.sessionHint": "Vous resterez connecté pendant 30 jours sur cet appareil.",
  "auth.creating": "Création en cours...",
  "auth.createMine": "Créer mon compte",
  "auth.haveAccount": "Déjà un compte ?",
  "auth.firstNameRequired": "Prénom requis",
  "auth.lastNameRequired": "Nom requis",
  "auth.emailInvalid": "Email invalide",
  "auth.passwordsMismatch": "Les mots de passe ne correspondent pas",
  "auth.acceptRequired": "Vous devez accepter les conditions",
  "auth.registerError": "Erreur lors de l'inscription",
  "auth.forgotTitle": "Mot de passe oublié",
  "auth.forgotMeta": "Réinitialisez le mot de passe de votre compte OTOPIECES.COM.",
  "auth.forgotIntro": "Indiquez votre adresse e-mail : nous vous enverrons un lien pour choisir un nouveau mot de passe.",
  "auth.checkInbox": "Vérifiez votre boîte de réception",
  "auth.sentBefore": "Si un compte existe avec l'adresse",
  "auth.sentAfter": ", un e-mail contenant un lien de réinitialisation (valable 1 heure) vient d'être envoyé.",
  "auth.spam": "Pensez à vérifier vos courriers indésirables.",
  "auth.backLogin": "Retour à la connexion",
  "auth.emailAddress": "Adresse e-mail",
  "auth.sendLink": "Envoyer le lien de réinitialisation",
  "auth.emailAddressInvalid": "Adresse e-mail invalide",
  "auth.genericError": "Une erreur est survenue, réessayez dans un instant",
  "auth.resetTitle": "Nouveau mot de passe",
  "auth.resetMeta": "Choisissez un nouveau mot de passe pour votre compte OTOPIECES.COM.",
  "auth.account": "Compte :",
  "auth.linkIncomplete": "Lien incomplet : ouvrez le lien reçu par e-mail.",
  "auth.linkInvalid": "Lien invalide ou expiré",
  "auth.requestNew": "Demander un nouveau lien",
  "auth.changed": "Mot de passe modifié !",
  "auth.redirecting": "Vous êtes maintenant connecté. Redirection en cours…",
  "auth.newPassword": "Nouveau mot de passe",
  "auth.min8Ph": "8 caractères minimum",
  "auth.saveNew": "Enregistrer le nouveau mot de passe",
  "auth.min8Long": "Le mot de passe doit contenir au moins 8 caractères",
  "auth.cannotChange": "Impossible de modifier le mot de passe",
  "auth.tooMany": "Trop de demandes. Réessayez dans 15 minutes.",
  "auth.linkInvalidDetail": "Ce lien de réinitialisation est invalide ou a expiré. Demandez un nouveau lien.",
  "common.loading": "Chargement…",
  "search.parts": "Pièces {b}",
  "search.metaQuery": "Recherche « {q} »",
  "search.metaDefault": "Recherche de pièces",
  "search.metaDesc": "Résultats de recherche pour {q} sur OTOPIECES.COM : {n} produit(s) trouvé(s).",
  "search.brandPage": "Voir la page marque",
  "search.resultsFor": "Résultats pour « {q} »",
  "search.title": "Recherche",
  "search.noMatch": "Aucun produit ne correspond à « {q} »",
  "search.hint": "Saisissez un mot-clé, une marque ou une référence",
  "search.showUnfiltered": "Voir les {n} résultats non filtrés par véhicule",
  "brands.metaTitle": "Toutes les marques de pièces auto de A à Z",
  "brands.metaDesc": "Découvrez les {n} marques de pièces détachées disponibles sur OTOPIECES.COM{list}. Qualité d'origine et garantie 2 ans.",
  "brands.all": "Toutes les marques",
  "brands.countAZ": { one: "{n} marque de pièces détachées, classée de A à Z", other: "{n} marques de pièces détachées, classées de A à Z" },
  "brands.searchPh": "Rechercher une marque…",
  "brands.noMatch": "Aucune marque ne correspond à « {q} ».",
  "search.nearTitle": "Vouliez-vous dire… références proches",
  "search.nearVia": "via la réf.",
  "partRequest.cta": "Demander cette pièce",
  "partRequest.ctaHint": "Nous recherchons la pièce pour vous auprès de nos fournisseurs et revenons vers vous par e-mail sous 24 h ouvrées.",
  "partRequest.title": "Demander cette pièce",
  "partRequest.intro": "Indiquez-nous vos coordonnées : notre équipe vérifie la disponibilité et le prix, puis vous répond par e-mail.",
  "partRequest.msgSearch": "Pièce recherchée",
  "partRequest.msgVehicle": "Véhicule",
  "partRequest.msgDetails": "Précisions",
  "partRequest.detailsPh": "Précisions utiles : référence constructeur, côté (gauche/droite), année, photo de la pièce…",
  "partRequest.submit": "Envoyer ma demande",
  "partRequest.sent": "Demande envoyée !",
  "partRequest.sentDesc": "Un accusé de réception vous a été envoyé par e-mail ; nous revenons vers vous rapidement.",
  "cat.topRated": "4 ★ et plus",
  "cat.topRatedTitle": "Afficher uniquement les pièces notées 4/5 ou plus par nos clients",
  "brands.sortBy": "Trier :",
  "brands.sortAz": "A → Z",
  "brands.sortTrust": "Score de confiance",
  "brands.noReviews": "Pas encore d'avis",
  "brands.trustHint": { one: "{n} marque notée par nos clients — les mieux notées d'abord, puis les marques sans avis par ordre alphabétique.", other: "{n} marques notées par nos clients — les mieux notées d'abord, puis les marques sans avis par ordre alphabétique." },
  "brand.notFound": "Marque introuvable",
  "brand.metaCat": "{c} {b} — Pièces auto",
  "brand.metaTitle": "Pièces {b} — Catalogue et prix",
  "brand.metaDesc": "Toutes les pièces détachées {b} : {n} produit(s) dans {cats}. Qualité d'origine, garantie 2 ans, livraison rapide en France.",
  "brand.noProducts": "Aucun produit « {b} » dans notre catalogue.",
  "brand.eyebrow": "Marque de pièces",
  "brand.products": { one: "{n} produit", other: "{n} produits" },
  "brand.categories": { one: "{n} catégorie", other: "{n} catégories" },
  "cmp.title": "Comparaison de produits",
  "cmp.addFailed": "Ajout impossible",
  "cmp.price": "Prix TTC",
  "cmp.oldPrice": "Prix barré",
  "cmp.discount": "Remise",
  "cmp.rating": "Note clients",
  "cmp.availability": "Disponibilité",
  "cmp.inStock": "En stock",
  "cmp.outOfStock": "Rupture",
  "cmp.ref": "Référence",
  "cmp.subcategory": "Sous-catégorie",
  "cmp.soldBy": "Vendu par",
  "cmp.pack": "lot",
  "cmp.packs": "Conditionnements",
  "cmp.warranty": "Garantie",
  "cmp.twoYears": "2 ans",
  "cmp.compat": "Compatibilité",
  "cmp.universal": "Universel",
  "cmp.intro": "{n}/{max} produits · ajoutez des pièces d'une même catégorie depuis les cartes produit (icône balance).",
  "cmp.clear": "Vider le comparateur",
  "cmp.empty": "Votre comparateur est vide",
  "cmp.emptyHint": "Parcourez le catalogue et cliquez sur l'icône balance pour comparer jusqu'à {max} pièces.",
  "cmp.browse": "Voir les pièces",
  "cmp.remove": "Retirer",
  "nf.metaTitle": "Page introuvable (404)",
  "nf.title": "Cette pièce n'est pas au catalogue…",
  "nf.text": "La page demandée a été déplacée, supprimée ou n'a jamais existé. Pas de panique : le bon chemin est juste en dessous.",
  "nf.searchPh": "Rechercher une pièce, une référence, une marque…",
  "nf.search": "Rechercher",
  "nf.topCategories": "Catégories les plus recherchées",
  "wl.guestBefore": "Votre liste est enregistrée sur cet appareil.",
  "wl.guestLogin": "Connectez-vous",
  "wl.guestAfter": "pour la retrouver partout et la conserver.",
  "chat.tooShort": "Décrivez votre demande en quelques mots (10 caractères minimum).",
  "chat.failed": "Envoi impossible, réessayez.",
  "chat.open": "Contacter le service client",
  "chat.greeting": "Bonjour ! Posez votre question, un conseiller vous répond par e-mail.",
  "chat.another": "Envoyer un autre message",
  "chat.sent": "Message envoyé !",
  "chat.replyTime": "Réponse par e-mail sous 24 h ouvrées",
  "chat.reference": "Référence",
  "chat.messagePh": "Tapez votre message...",
  "chat.emailPh": "Votre e-mail",
  "chat.namePh": "Votre nom",
  "contact.sent": "Message envoyé",
  "contact.failed": "Envoi impossible",
  "contact.address": "Adresse",
  "contact.phoneWa": "Téléphone / WhatsApp",
  "contact.hours": "Horaires",
  "contact.metaDesc": "Contactez le service client OTOPIECES.COM : téléphone, e-mail, formulaire. Réponse sous 24 h ouvrées.",
  "contact.heading": "Une question ? On vous répond.",
  "contact.intro": "Compatibilité d'une pièce, suivi de commande, retour ou facture : notre équipe de passionnés d'automobile est là pour vous aider.",
  "contact.tracking": "Suivi",
  "contact.returns": "Retours",
  "contact.writeUs": "Écrivez-nous",
  "contact.ackSent": "Un accusé de réception vous a été envoyé par e-mail ; nous vous répondons sous 24 h ouvrées.",
  "contact.message": "Message",
  "contact.received": "Message bien reçu !",
  "contact.fullName": "Nom complet",
  "contact.newMessage": "Nouveau message",
  "contact.orderNo": "N° de commande (optionnel)",
  "contact.subject": "Sujet",
  "contact.phone": "Téléphone",
  "contact.privacyNote": "Vos données servent uniquement à traiter votre demande.",
  "contact.messagePh": "Décrivez votre demande (véhicule, référence de la pièce, problème rencontré…)",
  "contact.details": "Nos coordonnées",
  "contact.send": "Envoyer",
  "chat.page": "Page :",
  "chat.send": "Envoyer",
  "orders.invoicePdf": "Facture PDF",
  // Catalogue (BDD) & bannières
  "cat.all": "Toutes",
  "cat.filterSubs": "Filtrer les {n} sous-catégories…",
  "cat.noSubMatch": "Aucune sous-catégorie ne correspond à « {q} »",
  "cat.otherSubs": "Autres sous-catégories {name}",
  "cat.subsubs": "Sous-catégories de {name}",
  "xsell.badge": "Complément utile",
  "xsell.compatible": "Compatible avec votre véhicule",
  "xsell.addedTitle": "Ajouté au panier",
  "xsell.completeTitle": "Complétez votre achat",
  "xsell.completeHint": "Les indispensables pour réaliser votre intervention — à vous de choisir.",
  "xsell.continue": "Continuer mes achats",
  "xsell.cartTitle": "Les indispensables pour votre entretien",
  "xsell.cartHint": "Produits complémentaires utiles pour les pièces de votre panier.",
  "xsell.productTitle": "Produits complémentaires",
  "xsell.productHint": "Souvent nécessaires pour cette intervention.",
  "cat.quickFilters": "Filtres rapides",
  "cat.quickFiltersHint": "Choisissez une sous-catégorie de {name} et une marque : la bonne pièce en deux clics.",
  "cat.nProducts": { one: "{n} produit", other: "{n} produits" },
  "banner.discover": "Découvrir",
  "banner.prev": "Bannière précédente",
  "banner.next": "Bannière suivante",
  "banner.n": "Bannière {n}",
  // À propos
  "about.title": "Qui sommes-nous",
  "about.eyebrow": "À propos",
  "about.heading": "{name}, la pièce auto sans prise de tête",
  "about.intro": "Née de la frustration de ne jamais trouver la bonne référence, notre boutique réunit catalogue constructeur, conseils d'experts et livraison express.",
  "about.description": "{name} : le spécialiste français des pièces détachées auto en ligne. Notre histoire, nos valeurs, notre équipe.",
  "about.kpiRefs": "références en stock",
  "about.kpiMakers": "équipementiers d'origine",
  "about.kpiBrands": "marques de véhicules",
  "about.kpiShip": "délai d'expédition",
  "about.kpiShipValue": "24 h",
  "about.storyTitle": "Notre histoire",
  "about.story1": "Tout commence dans un garage indépendant : trop de temps perdu à chercher une référence, trop d'erreurs de compatibilité, trop de délais. Nous avons décidé de construire l'outil que nous aurions aimé avoir : un catalogue exact par motorisation, des prix d'équipementier et une livraison qui tient ses promesses.",
  "about.story2": "Aujourd'hui, particuliers et professionnels commandent chez {name} des pièces de freinage, filtration, distribution, suspension ou carrosserie des plus grandes marques — TRW, Bosch, Brembo, Valeo, Mann-Filter, LuK… — avec la garantie de la bonne pièce, au bon prix.",
  "about.promiseLabel": "Notre promesse",
  "about.promise": "« La bonne pièce, livrée vite, au prix juste — et un humain au bout du fil si besoin. »",
  "about.valuesTitle": "Nos valeurs",
  "about.v1Title": "La bonne pièce, du premier coup",
  "about.v1Text": "Compatibilité vérifiée par motorisation exacte et recherche par plaque : zéro erreur de référence.",
  "about.v2Title": "Le prix juste",
  "about.v2Text": "Achat direct auprès des équipementiers d'origine, prix dégressifs et tarifs pros transparents.",
  "about.v3Title": "Vite livré, bien livré",
  "about.v3Text": "Expédition sous 24 h, transporteurs partenaires et suivi en temps réel jusqu'à votre porte.",
  "about.v4Title": "Responsable",
  "about.v4Text": "Emballages recyclés, reconditionnement des retours et partenaires certifiés.",
  "about.teamTitle": "L'équipe",
  "about.t1Name": "Service client",
  "about.t1Role": "Réponse sous 24 h ouvrées",
  "about.t2Name": "Experts techniques",
  "about.t2Role": "Mécaniciens & carrossiers",
  "about.t3Name": "Logistique",
  "about.t3Role": "Préparation & expédition",
  "about.t4Name": "Achats",
  "about.t4Role": "Sélection des équipementiers",
  "about.joinTitle": "Envie de nous rejoindre ou de travailler avec nous ?",
  "about.joinText": "Carrières, partenariats, presse : parlons-en.",
  "about.careers": "Carrières",
  "about.contact": "Nous contacter",
  // Garantie & retours
  "ret.title": "Garantie & retours",
  "ret.description": "Retour sous 14 jours, garantie 2 ans sur toutes les pièces OTOPIECES.COM. Procédure de retour en 4 étapes.",
  "ret.heading": "Satisfait ou remboursé, garanti 2 ans",
  "ret.intro": "Une erreur de référence, une pièce qui ne convient pas ? Le retour est simple et le remboursement rapide.",
  "ret.k1": "14 jours",
  "ret.k1Text": "pour changer d'avis",
  "ret.k2": "2 ans",
  "ret.k2Text": "de garantie constructeur",
  "ret.k3": "5 jours",
  "ret.k3Text": "pour être remboursé",
  "ret.stepsTitle": "Retourner une pièce en 4 étapes",
  "ret.s1Title": "Déclarez le retour",
  "ret.s1Text": "Depuis « Mes commandes », annulez ou contactez-nous en indiquant le numéro de commande et la pièce concernée.",
  "ret.s2Title": "Emballez la pièce",
  "ret.s2Text": "Pièce non montée, dans son emballage d'origine avec la facture. Nous vous envoyons l'étiquette de retour.",
  "ret.s3Title": "Déposez le colis",
  "ret.s3Text": "En bureau de poste ou point relais sous 14 jours. Le suivi nous informe de la réception.",
  "ret.s4Title": "Remboursement",
  "ret.s4Text": "Sous 5 jours après contrôle : sur votre moyen de paiement ou en avoir immédiat sur votre compte de dépôt.",
  "ret.coveredTitle": "Couvert par la garantie",
  "ret.covered1": "Défaut de fabrication ou de matière",
  "ret.covered2": "Pièce non conforme à la référence commandée",
  "ret.covered3": "Casse ou pièce manquante à la livraison",
  "ret.covered4": "Panne prématurée dans des conditions normales d'utilisation",
  "ret.notCoveredTitle": "Non couvert",
  "ret.notCovered1": "Pièce montée, utilisée ou modifiée",
  "ret.notCovered2": "Usure normale (plaquettes, disques, filtres…)",
  "ret.notCovered3": "Montage non conforme aux préconisations constructeur",
  "ret.notCovered4": "Retour hors délai de 14 jours ou sans emballage d'origine",
  "ret.ctaTitle": "Prêt à retourner une pièce ?",
  "ret.ctaText": "Rendez-vous dans vos commandes pour annuler ou déclarer un retour, ou contactez notre service client.",
  "ret.ctaOrders": "Demander un retour",
  "ret.ctaContact": "Nous contacter",
  // Plan du site
  "sm.title": "Plan du site",
  "sm.description": "Toutes les pages d'OTOPIECES.COM : catégories de pièces, marques, espace client, informations.",
  "sm.eyebrow": "Navigation",
  "sm.intro": "Retrouvez en un coup d'œil l'ensemble des rubriques de la boutique.",
  "sm.shop": "Boutique",
  "sm.account": "Mon compte",
  "sm.help": "Aide",
  "sm.home": "Accueil",
  "sm.allParts": "Toutes les pièces",
  "sm.brandsAZ": "Marques de A à Z",
  "sm.guides": "Guides & conseils",
  "sm.compare": "Comparateur",
  "sm.cart": "Panier",
  "sm.myOto": "Mon OTOPIECES",
  "sm.garage": "Mon garage",
  "sm.pro": "Compte professionnel",
  "sm.orders": "Mes commandes",
  "sm.wishlist": "Ma liste de souhaits",
  "sm.addresses": "Carnet d'adresses",
  "sm.bank": "Coordonnées bancaires",
  "sm.wallet": "Compte de dépôt",
  "sm.settings": "Paramètres",
  "sm.login": "Connexion",
  "sm.register": "Inscription",
  "sm.contact": "Contact",
  "sm.shipping": "Livraison & suivi",
  "sm.returns": "Garantie & retours",
  "sm.about": "Qui sommes-nous",
  "sm.sitemap": "Plan du site",
  "sm.categories": "Catégories de pièces",
  "sm.vehicleBrands": "Marques de véhicules",
  "sm.makers": "Équipementiers",
  "sm.pages": "Informations & pages légales",
  // Mon garage
  "garage.title": "Mes véhicules",
  "garage.add": "Ajouter un véhicule",
  "garage.intro": "Enregistrez vos véhicules pour retrouver en un clic les pièces compatibles. En ajoutant votre plaque d'immatriculation, elle sera reconnue par la recherche par plaque après validation par notre équipe.",
  "garage.selectRequired": "Sélectionnez la marque, le modèle et l'année",
  "garage.addedPlate": "Véhicule ajouté — sa plaque sera reconnue par la recherche par immatriculation après validation par notre équipe",
  "garage.added": "Véhicule ajouté",
  "garage.addError": "Erreur lors de l'ajout du véhicule",
  "garage.confirmDelete": "Supprimer {name} ?",
  "garage.deleted": "Véhicule supprimé",
  "garage.newVehicle": "Nouveau véhicule",
  "garage.brand": "Marque *",
  "garage.model": "Modèle *",
  "garage.year": "Année *",
  "garage.engine": "Motorisation",
  "garage.hp": "ch",
  "garage.platePh": "Plaque d'immatriculation (optionnel) — AA-123-BB",
  "garage.labelPh": "Surnom (optionnel) — ex : Voiture de Marie",
  "garage.cancel": "Annuler",
  "garage.save": "Enregistrer",
  "garage.empty": "Aucun véhicule enregistré pour le moment.",
  "garage.plateValidated": "Plaque validée",
  "garage.plateRefused": "Plaque refusée",
  "garage.platePending": "Plaque en attente de validation",
  "garage.useSelected": "Véhicule sélectionné · Voir les pièces",
  "garage.use": "Utiliser ce véhicule",
  "garage.delete": "Supprimer",
  // Carnet d'entretien
  "mb.mileage": "Kilométrage actuel",
  "mb.mileagePh": "ex. 85000",
  "mb.yearly": "Km / an (estimation)",
  "mb.save": "Enregistrer",
  "mb.overdueKm": "dépassé de {n} km",
  "mb.inKm": "dans {n} km",
  "mb.overdueDays": "dépassé de {n} j",
  "mb.inDays": "dans {n} j",
  "mb.lastPurchase": "dernier achat {date}",
  "mb.seeParts": "Voir les pièces",
  "mb.noVehicle1": "Ajoutez un véhicule dans",
  "mb.noVehicleLink": "Mon garage",
  "mb.noVehicle2": "pour activer votre carnet d'entretien prédictif.",
  "mb.estimated": "estimés aujourd'hui",
  "mb.enterMileage": "Renseignez votre kilométrage pour recevoir vos échéances d'entretien (distribution, freins, filtres…).",
  "mb.alertsTitle": "Alertes envoyées",
  "mb.see": "Voir",
  "mb.diagTitle": "Mes vérifications par photo",
  "mb.diagEmpty": "Aucune demande. Le bouton « Vérifier ma pièce par photo » est disponible sur les fiches produits techniques.",
  "mb.partToIdentify": "Pièce à identifier",
  "mb.confirmed": "Référence confirmée",
  "mb.rejected": "Non identifiée",
  "mb.pending": "En attente de validation",
  "mb.ref": "Réf. {ref}",
  "mb.aiLead": "Piste IA : {ref} ({c} %)",
  "mb.seePart": "Voir la pièce",
  "promo.copyCode": "Copier le code",
  "promo.copied": "Code copié !",
  "winter.myTyres": "Voir mes pneus hiver",
  "winter.seeTyres": "Voir les pneus hiver",
  "winter.close": "Fermer",
  "cat.reset": "Réinitialiser",
  "cat.resetFilters": "Réinitialiser les filtres",
  "cat.guideTitle": "{kw} : le guide OTOPIECES",
  "cat.aboutTitle": "À propos : {name}",
  "cat.faqTitle": "Questions fréquentes : {name}",
  "search.seeAll": "Voir tous les résultats pour « {q} »",
  "product.refLabel": "Réf.",
  "content.notFound": "Page introuvable",
  "content.backHome": "Retour à l'accueil",
  "content.updatedOn": "Mis à jour le {date}",
  "blog.title": "Magazine OTOPIECES.COM",
  "blog.intro": "Découvrez nos guides pratiques, conseils d'entretien et astuces pour prendre soin de votre véhicule.",
  "blog.searchPh": "Rechercher un article...",
  "blog.empty": "Aucun article trouvé",
  "blog.featured": "Article à la une",
  "blog.notFound": "Article introuvable",
  "blog.backToList": "Retour aux guides",
  "blog.readTime": "{time} de lecture",
  "blog.share": "Partager :",
  "blog.related": "Articles similaires",
  "blog.popular": "Catégories populaires",
  "blog.catOil": "Huile moteur",
  "blog.catBrakes": "Freinage",
  "blog.catMaintenance": "Entretien",
  "blog.catElectric": "Électrique",
  "blog.nArticles": { "one": "{n} article", "other": "{n} articles" },
  "blog.video1": "Comment faire des économies en achetant des pièces détachées ?",
  "blog.video2": "Que faire si le voyant moteur s'allume",
  "blog.video3": "TOP 8 des erreurs commises par les propriétaires de voitures",
  "frev.l1": "Très décevant",
  "frev.l2": "Décevant",
  "frev.l3": "Correct",
  "frev.l4": "Bien",
  "frev.l5": "Excellent",
  "frev.invalidLink": "Lien invalide",
  "frev.sendError": "Envoi impossible",
  "frev.title": "Votre avis sur le centre",
  "frev.intro": "Bonjour {name}, vos {n} pneu(s) ont été montés chez",
  "frev.on": "le",
  "frev.order": "commande",
  "frev.thanks": "Merci pour votre avis !",
  "frev.already": "Vous avez déjà noté ce centre.",
  "frev.replyFrom": "Réponse de {author}",
  "frev.backShop": "Retour à la boutique",
  "frev.question": "Comment s'est passé votre rendez-vous de montage ?",
  "frev.clickStar": "Cliquez sur une étoile",
  "frev.comment": "Votre commentaire (optionnel)",
  "frev.commentPh": "Accueil, ponctualité, qualité du montage…",
  "frev.submit": "Envoyer mon avis",
  "notif.title": "Notifications",
  "notif.empty": "Aucune notification pour le moment.",
  "notif.maintenanceLink": "Mon carnet d'entretien",
  "notif.agoMin": "il y a {n} min",
  "notif.agoH": "il y a {n} h",
  "notif.agoD": "il y a {n} j",
  "notif.refConfirmed": "Référence confirmée pour votre pièce",
  "notif.photoRequest": "Votre demande de vérification photo",
  "notif.fittingMoved": "Rendez-vous de montage déplacé",
  "notif.fittingConfirmed": "Rendez-vous de montage confirmé",
  "notif.fittingTomorrow": "Montage de vos pneus demain",
  "notif.maintenance": "Entretien à prévoir : {sub} ({vehicle})",
  "notif.k.diag_auto.title": "Référence confirmée pour votre pièce",
  "notif.k.diag_auto.body": "Référence {ref} ({brand}) confirmée par analyse photo : {explanation}",
  "notif.k.diag_rejected.title": "Votre demande de vérification photo",
  "notif.k.diag_rejected.body": "{message}",
  "notif.k.diag_rejected_default.title": "Votre demande de vérification photo",
  "notif.k.diag_rejected_default.body": "Nous n'avons pas pu identifier la pièce sur votre photo. Merci de réessayer avec une photo plus nette ou de contacter notre service client.",
  "notif.k.diag_admin.title": "Référence confirmée pour votre pièce",
  "notif.k.diag_admin.body": "Notre équipe a vérifié votre photo : la référence à commander est {ref}{brand_suffix}. {message}",
  "notif.k.maintenance_km.title": "Entretien à prévoir : {sub} ({vehicle})",
  "notif.k.maintenance_km.body": "D'après votre kilométrage, votre {sub} arrive à échéance dans environ {km} km. Voici les pièces compatibles avec votre {vehicle}.",
  "notif.k.maintenance_now.title": "Entretien à prévoir : {sub} ({vehicle})",
  "notif.k.maintenance_now.body": "D'après votre kilométrage, votre {sub} arrive à échéance dès maintenant. Voici les pièces compatibles avec votre {vehicle}.",
  "notif.k.maintenance_days.title": "Entretien à prévoir : {sub} ({vehicle})",
  "notif.k.maintenance_days.body": "D'après votre kilométrage, votre {sub} arrive à échéance dans {days} jours. Voici les pièces compatibles avec votre {vehicle}.",
  "notif.k.fit_confirmed.title": "Rendez-vous de montage confirmé",
  "notif.k.fit_confirmed.body": "{centre} ({city}) confirme le montage de vos pneus le {date} — commande {order}.",
  "notif.k.fit_confirmed_requested.title": "Rendez-vous de montage confirmé",
  "notif.k.fit_confirmed_requested.body": "{centre} ({city}) confirme le montage de vos pneus le {date} (créneau demandé : {requested}) — commande {order}.",
  "notif.k.fit_moved.title": "Rendez-vous de montage déplacé",
  "notif.k.fit_moved.body": "{centre} ({city}) a déplacé votre rendez-vous au {date} — commande {order}.",
  "notif.k.fit_reminder.title": "Montage de vos pneus demain",
  "notif.k.fit_reminder.body": "Rappel : rendez-vous le {date} chez {centre}, {address}.",
  "notif.k.fit_reassigned_kept.title": "Nouveau centre de montage",
  "notif.k.fit_reassigned_kept.body": "Le montage de vos pneus (commande {order}) est désormais assuré par {centre} — {address}. Votre créneau du {date} est conservé, à confirmer par le centre.",
  "notif.k.fit_reassigned_propose.title": "Nouveau centre de montage",
  "notif.k.fit_reassigned_propose.body": "Le montage de vos pneus (commande {order}) est désormais assuré par {centre} — {address}. Le centre vous proposera une date.",
  "notif.k.fit_review_reply.title": "Le centre a répondu à votre avis",
  "notif.k.fit_review_reply.body": "{centre} : « {excerpt} »",
  "notif.k.fit_cancelled_credit.title": "Montage annulé — avoir généré",
  "notif.k.fit_cancelled_credit.body": "Avoir {number} de {amount} crédité sur votre compte de dépôt (commande {order}).",
  "notif.k.fit_card_refund.title": "Avoir remboursé sur votre moyen de paiement",
  "notif.k.fit_card_refund.body": "L'avoir {number} de {amount} vous est remboursé sur votre {method} (délai bancaire 3 à 10 jours).",
  "acc.notifications": "Notifications",
  "notif.seeAll": "Voir toutes mes notifications",
  "nc.kind.all": "Toutes",
  "nc.kind.fitting": "Montage",
  "nc.kind.diagnostic": "Diagnostic photo",
  "nc.kind.maintenance": "Entretien",
  "nc.unreadOnly": "Non lues uniquement",
  "nc.readAll": "Tout marquer comme lu",
  "nc.prefs": "Préférences",
  "nc.markRead": "Marquer comme lu",
  "nc.markUnread": "Marquer comme non lu",
  "nc.delete": "Supprimer",
  "nc.empty": "Aucune notification pour ce filtre.",
  "nc.prev": "Précédent",
  "nc.next": "Suivant",
  "nc.pageOf": "Page {page} / {pages}",
  "nc.prefsTitle": "Préférences de notifications",
  "nc.prefsIntro": "Choisissez, pour chaque type de notification, si vous souhaitez aussi la recevoir par e-mail ou uniquement dans la cloche du site.",
  "nc.emailAndBell": "E-mail + cloche",
  "nc.bellOnly": "Cloche uniquement",
  "nc.transactionalNote": "Les e-mails indispensables (confirmation de commande, expédition, facture, avoir, mot de passe) sont toujours envoyés.",
  "nc.ch.diagnostic": "Diagnostic photo",
  "nc.chDesc.diagnostic": "Référence confirmée ou demande de vérification traitée par notre équipe.",
  "nc.ch.maintenance": "Entretien à prévoir",
  "nc.chDesc.maintenance": "Rappels d'entretien calculés d'après le kilométrage de vos véhicules.",
  "nc.ch.fitting": "Montage de pneus",
  "nc.chDesc.fitting": "Rendez-vous confirmé ou déplacé, rappel la veille, changement de centre.",
  "nc.ch.reviews": "Avis & réponses",
  "nc.chDesc.reviews": "Invitations à donner votre avis et réponses du centre ou de notre équipe à vos avis.",
  "nc.ch.alerts": "Alertes prix, liste d'envies & questions",
  "nc.chDesc.alerts": "Baisse de prix ou retour en stock d'un article suivi, réponse à vos questions produit.",
  "ps.title": "Espace centre partenaire",
  "ps.invalidLink": "Lien invalide",
  "ps.savedSchedule": "Horaires enregistrés : les clients peuvent désormais réserver un créneau chez vous.",
  "ps.saveFailed": "Enregistrement impossible",
  "ps.savedLang": "Langue enregistrée : {lang}.",
  "ps.langFailed": "Langue non enregistrée",
  "ps.perTyre": "/ pneu",
  "ps.langHint": "Langue de cet espace et des e-mails que nous vous envoyons",
  "ps.langLabel": "Langue",
  "ps.slotsTitle": "Mes créneaux de montage",
  "ps.slotsIntro": "Indiquez vos plages d'ouverture par jour : les clients choisiront un créneau libre lors de leur commande, vous recevrez un e-mail pour le confirmer.",
  "ps.upcomingTitle": "Prochains rendez-vous",
  "ps.noUpcoming": "Aucun rendez-vous à venir.",
  "ps.nTyres": "{n} pneu(s)",
  "ps.toConfirm": "À confirmer",
  "ps.confirmed": "Confirmé",
  "ps.confirm": "Confirmer",
  "ps.edit": "Modifier",
  "ps.reviewsTitle": "Avis de mes clients",
  "ps.reviewsIntro": "Vos réponses sont publiques (visibles par les clients au moment de choisir un centre) ; le client est prévenu par e-mail lors de votre première réponse.",
  "ps.noReviews": "Aucun avis pour le moment.",
  "ps.slotDuration": "Durée d'un créneau",
  "ps.leadDays": "Délai minimum (jours, réception des pneus)",
  "ps.capacity": "Véhicules par créneau",
  "ps.weekPreset": "Semaine type (Lun–Ven 8h–12h / 14h–18h, Sam 9h–12h)",
  "ps.addRange": "plage",
  "ps.closed": "Fermé",
  "ps.rangeError": "Chaque plage doit avoir une heure de fin postérieure à l'heure de début.",
  "ps.saveSchedule": "Enregistrer les horaires",
  "ps.ofScore": "{n} % du score",
  "ps.noDelay": "Aucune confirmation mesurée pour l'instant",
  "ps.delayUnderHour": "Délai moyen de confirmation : moins d'une heure",
  "ps.delayAvg": "Délai moyen de confirmation : {d} (100 si ≤ 12 h, 0 au-delà de 96 h)",
  "ps.dayShort": "j",
  "ps.relTitle": "Ma fiabilité",
  "ps.relWindow": "sur les {n} derniers jours, mise à jour en temps réel",
  "ps.relIntro": "Les clients voient d'abord les centres les plus fiables. Un score « À surveiller » (moins de 40) sur au moins {n} commandes masque temporairement le centre au moment de la commande.",
  "ps.visible": "Proposé aux clients",
  "ps.hidden": "Masqué au checkout",
  "ps.since": "depuis le {d}",
  "ps.relEmpty": "Pas encore de commande sur la période : votre score apparaîtra dès le premier montage.",
  "ps.barConfirmed": "Rendez-vous confirmés",
  "ps.confirmedOf": "{c} confirmé(s) sur {o} commande(s)",
  "ps.pendingN": "{n} en attente de votre confirmation",
  "ps.barDelay": "Rapidité de réponse",
  "ps.barKept": "Commandes conservées",
  "ps.reassignedN": "{n} commande(s) réaffectée(s) à un autre centre faute de réponse",
  "ps.noReassigned": "Aucune commande réaffectée — parfait",
  "ps.pointsTitle": "Points à améliorer",
  "ps.keepGoing": "Continuez ainsi",
  "ps.excellent": "Score excellent : vous êtes affiché en tête de liste chez les clients proches de vous.",
  "ps.ratingLine": "Note clients : {avg}/5 sur {count} avis · {upcoming} rendez-vous à venir.",
  "ps.histEmpty": "Historique disponible dès la première semaine avec des commandes.",
  "ps.histTitle": "Évolution du score sur {n} semaines",
  "ps.calTitle": "Ajouter mes rendez-vous à mon agenda",
  "ps.calIntro": "Abonnez votre agenda à ce lien : les montages (confirmés et à confirmer) apparaissent automatiquement dans Google Agenda, Outlook ou Apple Calendar, mis à jour toutes les heures.",
  "ps.copied": "Copié",
  "ps.copyLink": "Copier le lien",
  "ps.subscribe": "S'abonner (Apple / Outlook)",
  "ps.downloadIcs": "Télécharger le .ics",
  "ps.calGoogle": "Autres agendas (+) → « À partir de l'URL » → collez le lien.",
  "ps.calOutlook": "Ajouter un calendrier → « S'abonner à partir du web » → collez le lien.",
  "ps.calApple": "Fichier → Nouvel abonnement à un calendrier, ou cliquez sur « S'abonner ».",
  "ps.sendFailed": "Envoi impossible",
  "ps.deleteReplyConfirm": "Supprimer votre réponse ?",
  "ps.editReply": "Modifier ma réponse",
  "ps.reply": "Répondre",
  "ps.replyPlaceholder": "Merci pour votre retour…",
  "ps.publicReply": "réponse publique",
  "ps.customerNotified": "le client est prévenu par e-mail",
  "ps.publish": "Publier",
  "ps.stValidated": "Validé le {d}",
  "ps.stDisputed": "Contesté le {d} — en attente de traitement",
  "ps.stResolved": "Contestation traitée le {d}",
  "ps.actionFailed": "Action impossible",
  "ps.stFittings": {"one": "{count} montage", "other": "{count} montages"},
  "ps.stUpcoming": "{n} à venir",
  "ps.currentMonth": "mois en cours",
  "ps.reason": "Motif :",
  "ps.answer": "Réponse :",
  "ps.validateConfirm": "Valider le relevé de {m} ({a} TTC) ? Cette validation est définitive.",
  "ps.validate": "Valider le relevé",
  "ps.dispute": "Contester",
  "ps.disputeReason": "Motif de la contestation (montage manquant, montant erroné, …)",
  "ps.disputePlaceholder": "Ex. : le montage de la commande OP-… du 12/09 n'apparaît pas sur le relevé.",
  "ps.sendDispute": "Envoyer la contestation",
  "ps.cancel": "Annuler",
  "ps.stTitle": "Mes relevés mensuels",
  "ps.stIntro": "Chaque relevé récapitule les montages confirmés et réalisés dans votre centre et le montant TTC à nous facturer. Une fois le mois terminé, validez-le avant d'émettre votre facture, ou contestez-le si un montage ou un montant est incorrect.",
  "ps.trend": "{d} pt depuis le {since}",
  "rel.excellent": "Excellent",
  "rel.good": "Bon",
  "rel.average": "Moyen",
  "rel.watch": "À surveiller",
  "rel.noData": "Pas assez de données",
  "rel.tip": "Confirmation {c} % · Délai de réponse {d}/100 · Réaffectations subies {r} ({rs}/100) · {n} commande(s)",
  "rel.detail": "conf. {c} % · délai {d} · réaff. {r}",
  "rel.weekTip": "Semaine du {d} : {s}/100 ({l}, {n} commande(s))",
  "nc.pushEnabledBg": "Notifications activées (même site fermé)",
  "nc.pushTest": "M'envoyer une notification test",
  "nc.pushTestResult": "Notification test envoyée à {sent} appareil(s) sur {devices}.",
  "nc.pushTestNone": "Aucun appareil abonné : activez d'abord les notifications sur cet appareil.",
  "ps.pushIntro": "Soyez alerté sur cet appareil, même espace fermé, dès qu'un client réserve, déplace ou annule un créneau de montage, ou qu'un montage vous est réaffecté.",
  "nc.ch.digest": "Résumé hebdomadaire",
  "nc.chDesc.digest": "Chaque lundi matin, un e-mail récapitulant vos notifications non lues de la semaine (désactivé par défaut).",
  "nc.digestOn": "Activé",
  "nc.digestOff": "Désactivé",
  "nc.pushTitle": "Notifications navigateur",
  "nc.pushDesc": "Recevez une alerte sur votre appareil dès qu'un rendez-vous de montage est confirmé ou déplacé, ou qu'une nouvelle notification arrive — même lorsque le site est fermé (Web Push).",
  "nc.pushEnable": "Activer les notifications navigateur",
  "nc.pushEnabled": "Notifications navigateur activées",
  "nc.pushDisable": "Désactiver",
  "nc.pushDenied": "Notifications bloquées par le navigateur : autorisez-les dans les réglages du site.",
  "nc.pushUnsupported": "Votre navigateur ne prend pas en charge les notifications.",
  "track.title": "Suivi de livraison",
  "track.created": "Commande confirmée",
  "track.createdDesc": "Votre paiement a été validé, nous préparons votre commande.",
  "track.processing": "Préparation en cours",
  "track.processingDesc": "Vos pièces sont contrôlées et emballées dans notre entrepôt.",
  "track.handed_over": "Colis remis au transporteur",
  "track.shipped": "Expédié",
  "track.shippedDesc": "Votre colis est en route.",
  "track.transit": "En transit",
  "track.delivered": "Livré",
  "track.deliveredDesc": "Votre colis a été livré. Bonne route !",
  "track.pending": "À venir",
  "track.eta": "Livraison estimée : {d}",
  "track.carrierLink": "Suivre chez {carrier}",
  "track.noNumber": "Le numéro de suivi vous sera communiqué dès l'expédition.",
  "track.help": "Une question sur votre livraison ? Toutes les étapes s'affichent ici en temps réel.",
  "track.lastUpdate": "Dernière mise à jour : {d}",
  "nc.ch.cart": "Rappel de panier",
  "nc.chDesc.cart": "Un e-mail si vous laissez des articles dans votre panier pendant 24 h.",
  "nc.kind.delivery": "Livraison",
  "nc.ch.delivery": "Suivi de livraison",
  "nc.chDesc.delivery": "Nouvelle étape de livraison ajoutée à votre commande (préparation, transit, livraison).",
  "notif.k.delivery_step.title": "Nouvelle étape de livraison — commande {order}",
  "notif.k.delivery_step.body": "{step}{loc} Suivez votre colis en temps réel dans Mes commandes.",
  "notif.k.delivery_processing.title": "Votre commande {order} est en préparation",
  "notif.k.delivery_processing.body": "Vos pièces sont contrôlées et emballées dans notre entrepôt. Prochaine étape : l'expédition.",
  "notif.k.delivery_shipped.title": "Votre commande {order} a été expédiée",
  "notif.k.delivery_shipped.body": "Votre colis est en route{loc}. Retrouvez le numéro de suivi dans Mes commandes.",
  "notif.k.delivery_delivered.title": "Votre commande {order} a été livrée",
  "notif.k.delivery_delivered.body": "Votre colis est arrivé. Bonne route ! N'hésitez pas à donner votre avis sur vos pièces.",
  "paylink.invalid": "Ce lien de paiement est invalide.",
  "paylink.fillCard": "Merci de renseigner toutes les informations de carte.",
  "paylink.failed": "Le paiement n'a pas pu être effectué.",
  "paylink.paid": "Cette commande est déjà payée. Merci !",
  "paylink.expired": "Ce lien de paiement a expiré. Contactez-nous pour en recevoir un nouveau.",
  "paylink.revoked": "Ce lien a été remplacé par un nouveau : consultez votre dernier e-mail.",
  "paylink.cancelled": "Cette commande a été annulée.",
  "paylink.successTitle": "Paiement confirmé",
  "paylink.successBody": "Merci ! Votre commande {o} est confirmée et sera préparée dès maintenant. Un e-mail de confirmation vous a été envoyé.",
  "paylink.orderFor": "Commande préparée pour {n}",
  "paylink.toPay": "À payer",
  "paylink.cardTitle": "Paiement sécurisé par carte",
  "paylink.holder": "Nom du titulaire",
  "paylink.payNow": "Payer {a}",
  "paylink.secure": "Connexion chiffrée · Vos données bancaires ne sont jamais stockées.",
  "orders.awaitingPayment": "En attente de paiement",
  "orders.payNow": "Payer maintenant",
  "checkout.sumupInfo": "Vous allez être redirigé vers la page de paiement sécurisée SumUp pour saisir vos informations de carte. Votre commande est confirmée dès que le paiement est accepté.",
  "checkout.walletCoversAll": "Votre avoir couvre la totalité de la commande : aucun paiement par carte n'est nécessaire.",
  "checkout.redirecting": "Redirection vers le paiement sécurisé…",
  "checkout.errPayment": "La commande est enregistrée mais le paiement n'a pas pu démarrer. Réessayez ou réglez plus tard depuis « Mes commandes ».",
  "checkout.retryPayment": "Réessayer le paiement",
  "paylink.sumupInfo": "Vous allez être redirigé vers la page de paiement sécurisée SumUp (carte bancaire, Apple Pay, Google Pay).",
  "payret.checking": "Vérification de votre paiement…",
  "payret.checkingHint": "Merci de patienter quelques secondes, nous confirmons le règlement auprès de SumUp.",
  "payret.paidTitle": "Paiement confirmé !",
  "payret.paidBody": "Merci pour votre commande. Un e-mail de confirmation vous a été envoyé et votre commande sera préparée dès maintenant.",
  "payret.failedTitle": "Paiement non abouti",
  "payret.failedBody": "Le paiement a été refusé ou annulé. Aucun montant n'a été débité. Vos articles restent réservés : vous pouvez réessayer.",
  "payret.pendingTitle": "Paiement en cours de confirmation",
  "payret.pendingBody": "Nous n'avons pas encore reçu la confirmation de SumUp. Si vous avez bien payé, votre commande passera automatiquement en « Payée » dans quelques minutes.",
  "payret.retry": "Réessayer le paiement",
  "payret.later": "Payer plus tard",
  "payret.errorTitle": "Commande introuvable",
  "orders.refundCard": "Commande remboursée sur votre carte bancaire ({a} €) — avoir {n}.",
  "orders.refundCardPartial": "Remboursement partiel de {a} € effectué sur votre carte bancaire — avoir {n}.",
  "orders.creditNotePdf": "Télécharger l'avoir (PDF)",
  "product.viewSpecs": "Les caractéristiques",
  "product.fitOk": "Compatible avec votre véhicule",
  "product.fitUniversal": "Produit universel : convient à tous les véhicules",
  "product.fitKo": "Ne convient pas à votre véhicule",
  "product.fitSeeCompatible": "Voir les pièces compatibles",
  "product.fitChangeVehicle": "Changer de véhicule",
  "product.fitSelectHint": "Sélectionnez votre véhicule pour vérifier la compatibilité",
  "product.fitSelectCta": "Sélectionner mon véhicule",
  "cmp.check": "Comparer",
  "cmp.checked": "Dans le comparateur",
  "cmp.added": "Ajouté au comparateur ({n}/{max})",
  "cmp.removed": "Retiré du comparateur",
  "cmp.maxReached": "Vous pouvez comparer {max} articles maximum",
  "cmp.sameSub": "Comparez uniquement des articles de la même sous-catégorie",
  "cmp.open": "Comparer",
  "cmp.barTitle": "Comparateur",
  "cmp.barHint": "Cochez 2 à {max} articles de la même sous-catégorie",
  "cmp.barCompare": "Comparer ({n})",
  "cmp.barNeedTwo": "Ajoutez au moins 2 articles",
  "cmp.colHeader": "Caractéristique",
  "cmp.specsTitle": "Caractéristiques techniques",
  "cmp.diffHint": "Les lignes surlignées indiquent des différences entre les articles.",
  "cmp.intro2": "{n}/{max} articles · cochez « Comparer » sur les cartes produit d'une même sous-catégorie.",
  "cmp.emptyHint2": "Parcourez le catalogue et cochez « Comparer » sur 2 à {max} articles d'une même sous-catégorie.",
  "header.fastShipping": "Livraison rapide 2-5 jours",
  "product.deliverySubFast": "2 à 5 jours ouvrés",
  "cart.fastShipping": "Livraison rapide 2-5 jours",
  "cart.freeShippingReached": "Livraison offerte : seuil atteint !",
  "header.deliveryCountry": "Pays de livraison",
  "header.freeFromShort": "offerte dès {n} €",
  "sess.title": "Appareils connectés",
  "sess.hint": "Sessions actuellement connectées à votre compte. Déconnectez un appareil que vous ne reconnaissez pas, ou tous les autres d'un coup.",
  "sess.logoutEverywhere": "Déconnecter partout",
  "sess.logout": "Déconnecter",
  "sess.thisDevice": "Cet appareil",
  "sess.lastSeen": "Dernière activité",
  "sess.remembered": "connexion mémorisée",
  "sess.revoked": "Appareil déconnecté",
  "sess.revokedAll": "{n} appareil(s) déconnecté(s)",
  "sess.confirmAll": "Déconnecter tous les autres appareils ? Vous resterez connecté sur celui-ci.",
  "sess.error": "Action impossible, réessayez",
  "sess.empty": "Aucune session active",
  "cart.remove": "Supprimer",
  "cat.specs": "Caractéristiques techniques",
  "cat.specsHint": "Affinez par dimension, type ou référence technique.",
  "cat.showMore": "Voir plus ({n})",
  "cat.showLess": "Voir moins",
  "garage.savedToast": "Véhicule enregistré dans votre garage",
  "garage.restoredToast": "Votre {v} a été restauré depuis votre compte",
  "garage.myVehicles": "Mes véhicules",
  "garage.manage": "Gérer mon garage",
  "cart.forVehicle": "Pièces pour votre véhicule",
  "equiv.title": "Références équivalentes",
  "equiv.count": { one: "{n} référence", other: "{n} références" },
  "equiv.search": "Filtrer…",
  "equiv.allBrands": "Toutes les marques ({n})",
  "equiv.brand": "Marque",
  "equiv.ref": "Référence",
  "equiv.type": "Type",
  "equiv.oem": "OEM constructeur",
  "equiv.alt": "Équivalence",
  "equiv.unknownBrand": "—",
  "equiv.empty": "Aucune référence ne correspond à ce filtre.",
  "equiv.seeAll": "Voir les {n} références ↓",
  "equiv.moreAlt": "+{n} équivalences",
  "equiv.brandLink": "Voir toutes les pièces référençant {b}",
  "search.equivBrand": "Pièces référençant {b}",
  "search.equivHint": "Pièces de la marque {b} et pièces d'autres fabricants qui indiquent une référence {b} équivalente.",
  "cart.fitOk": "Compatible avec votre {v}",
  "cart.fitNo": "Non confirmé pour votre {v}",
  "cart.fitUniversal": "Pièce universelle · tous véhicules",
  "cart.fitCheck": "Vérifier la fiche",
  "cart.fitWarn": { one: "{n} article n'est pas confirmé pour votre {v} : vérifiez sa compatibilité avant de commander.", other: "{n} articles ne sont pas confirmés pour votre {v} : vérifiez leur compatibilité avant de commander." },
  "alt.compatible": "Alternative compatible avec votre {v} chez {brand}",
  "alt.samePrice": "même prix",
  "alt.morePerUnit": "+{d} € / unité",
  "cart.garageSwitch": "Changer de véhicule (mon garage)",
  "cart.garagePick": "Choisir un véhicule de mon garage…",
  "cart.garageHint": "La compatibilité des articles est revérifiée instantanément.",
  "notify.button": "Prévenez-moi du retour en stock",
  "notify.title": "Alerte retour en stock",
  "notify.text": "Laissez votre e-mail : nous vous écrivons dès que cette pièce est de nouveau disponible (une seule fois, sans engagement).",
  "notify.emailPh": "votre@email.fr",
  "notify.submit": "Me prévenir",
  "notify.done": "C'est noté ! Vous recevrez un e-mail dès le retour en stock.",
  "notify.already": "Vous êtes déjà inscrit(e) pour cette pièce.",
  "notify.subscribed": "Alerte activée : vous serez prévenu(e) par e-mail",
  "notify.cancel": "Annuler l'alerte",
  "notify.error": "Impossible d'enregistrer votre demande. Vérifiez l'adresse e-mail.",
  "notify.priceButton": "Prévenez-moi si le prix baisse",
  "notify.priceTitle": "Alerte baisse de prix",
  "notify.priceText": "Laissez votre e-mail : nous vous écrivons dès que le prix de cette pièce baisse (une seule fois, sans engagement).",
  "notify.priceDone": "C'est noté ! Vous recevrez un e-mail si le prix baisse.",
  "notify.priceAlready": "Vous suivez déjà le prix de cette pièce.",
  "notify.priceSubscribed": "Alerte prix activée : vous serez prévenu(e) par e-mail",
  "acc.referral": "Parrainage",
  "share.rewardHint": "−{p} % offerts si un ami passe sa 1re commande via votre lien.",
  "share.rewardMore": "Mes récompenses",
  "share.rewardGuest": "Connectez-vous : −{p} % offerts si un ami commande via votre lien.",
  "share.rewardLogin": "Se connecter",
  "share.refTitle": "Partagez, gagnez −{p} %",
  "share.refHow": "Chaque fois qu'un ami passe sa première commande après avoir ouvert un lien que vous avez partagé (page, fiche produit, comparatif, guide), vous recevez par e-mail un code personnel de −{p} % valable {d} jours. Les boutons de partage du site ajoutent automatiquement votre code à vos liens.",
  "share.refDisabled": "Le programme est momentanément suspendu.",
  "share.refWhatsapp": "Je commande mes pièces auto ici, jette un œil :",
  "share.refTip": "Astuce : partagez directement une fiche produit ou votre sélection véhicule — le lien contient déjà votre code.",
  "share.refTotal": "Récompenses gagnées",
  "share.refActive": "Codes à utiliser",
  "share.refRewards": "Mes codes",
  "share.refEmpty": "Aucune récompense pour l'instant : partagez vos pièces préférées à vos proches !",
  "share.refStatus_active": "À utiliser",
  "share.refStatus_used": "Utilisé",
  "share.refStatus_expired": "Expiré",
  "share.refFriend": "Ami {f} · {d}",
  "share.refUntil": "jusqu'au {d}",
  "share.tier_none": "Pas encore de rang",
  "share.tier_bronze": "Parrain Bronze",
  "share.tier_silver": "Parrain Argent",
  "share.tier_gold": "Parrain Or",
  "share.badgeFriends": "{n} ami(s) converti(s)",
  "share.badgeNext": "Encore {n} ami(s) pour devenir {tier}",
  "share.badgeMax": "Rang maximal atteint — merci !",
  "share.badgeLevels": "Bronze dès 1 ami · Argent dès 3 · Or dès 10",
  "acc.alerts": "Mes alertes",
  "alerts.intro": "Vos alertes « Prévenez-moi » : retour en stock et baisse de prix. Chaque alerte vous envoie un seul e-mail, puis disparaît de cette liste.",
  "alerts.active": { one: "{n} alerte active", other: "{n} alertes actives" },
  "alerts.empty": "Aucune alerte active. Sur une fiche produit, cliquez « Prévenez-moi » pour être averti(e) du retour en stock ou d'une baisse de prix.",
  "alerts.kindStock": "Retour en stock",
  "alerts.kindPrice": "Baisse de prix",
  "alerts.remove": "Supprimer",
  "alerts.removeAll": "Tout supprimer",
  "alerts.removed": "Alerte supprimée",
  "alerts.removedAll": "Toutes les alertes ont été supprimées",
  "alerts.error": "Action impossible, réessayez",
  "alerts.since": "depuis le {d}",
  "alerts.priceWatch": "Prix suivi : {p} €",
  "alerts.now": "aujourd'hui",
  "alerts.backSoon": "De retour en stock — e-mail en cours d'envoi",
  "alerts.history": "Alertes envoyées (90 derniers jours)",
  "alerts.sentOn": "envoyée le {d}",
  "wl.priceAlerts": "Alerte prix sur toute la liste",
  "wl.priceAlertsHint": "Recevez un e-mail dès qu'une pièce de votre liste baisse de prix",
  "wl.priceAlertsDone": "Alerte prix activée sur {n} pièce(s) ({a} déjà suivie(s)). Retrouvez-les dans Mes alertes.",
  "equiv.showMore": "Voir plus ({n} autres références)",
  "equiv.showLess": "Voir moins",
  "spec.equivalences": "Références équivalentes",
  'equiv.compareTitle': 'Comparer les équivalences côte à côte',
  'equiv.compareSub': '{n} pièces équivalentes · la colonne surlignée est la pièce consultée',
  'equiv.openComparator': 'Ouvrir dans le comparateur',
  'equiv.current': 'Pièce consultée',
  'equiv.colBrand': 'Marque',
  'equiv.colRef': 'Référence',
  'equiv.colPrice': 'Prix TTC',
  'equiv.colRating': 'Avis clients',
  'equiv.colDelivery': 'Livraison',
  'equiv.colStock': 'Stock',
  'equiv.colType': 'Type',
  'equiv.cheapest': 'Le moins cher',
  'equiv.bestRated': 'Mieux noté',
  'equiv.fastest': 'le plus rapide',
  'equiv.bestMarket': 'Meilleur prix du marché',
  'equiv.stockLine': '{w} entrepôt',
  'equiv.stockSupplier': ' · +{s} fournisseur',
  'equiv.outOfStock': 'Rupture de stock',
  'equiv.supplierDelay': 'Sous {n} j (fournisseur)',
  'equiv.ship24': 'Expédié sous 24 h',
  'equiv.unavailable': 'Indisponible',
  'equiv.viewProduct': 'Voir la fiche',
  'equiv.hideCompare': 'Masquer le comparatif',
  'equiv.showCompare': 'Afficher le comparatif',
  'common.close': 'Fermer',
  'scan.title': 'Scanner le code-barres EAN',
  'scan.hint': 'Placez le code-barres de la pièce ou de son emballage dans le cadre : la fiche s\'ouvre automatiquement.',
  'scan.denied': 'Accès à la caméra refusé. Autorisez la caméra dans votre navigateur puis réessayez.',
  'scan.unavailable': 'Caméra indisponible sur cet appareil. Saisissez le code EAN dans la barre de recherche.',
  'scan.found': 'Pièce trouvée : {name}',
  'equiv.share': 'Partager le comparatif',
  'equiv.shareWhatsapp': 'Envoyer sur WhatsApp',
  'equiv.shareCopy': 'Copier le lien',
  'equiv.shareCopied': 'Lien du comparatif copié',
  'equiv.shareText': 'Peux-tu me dire quelle pièce choisir ? Comparatif OTOPIECES : {names}',
  'cmp.shared': { one: 'Comparatif partagé — {n} pièce', other: 'Comparatif partagé — {n} pièces' },
  'cmp.shareTitle': 'Partager ce comparatif',
  "fb.title": "Nos grandes marques",
  "fb.all": "Toutes les marques",
  "fb.nav": "Marques de pièces",
  "fb.parts": "Pièces {b}",
  "fb.logo": "Logo {b}",
  "seo.defaultTitle": "Pièces auto pas cher en ligne — Pièces détachées toutes marques",
  "seo.defaultDesc": "Pièces détachées auto au meilleur prix sur OTOPIECES.COM : freinage, filtres, moteur, pneus… Recherche par véhicule ou plaque, livraison 2-5 jours, retour 14 j.",
  "vb.title": "Pièces auto par marque de véhicule",
  "vb.meta": "Choisissez la marque de votre véhicule (Renault, Peugeot, Volkswagen, BMW, Citroën…) pour trouver tous les modèles et les pièces détachées compatibles.",
  "vb.crumb": "Marques de véhicules",
  "vb.intro": "Sélectionnez la marque de votre voiture pour découvrir tous ses modèles et les pièces détachées compatibles : freinage, filtration, moteur, pneus…",
  "vb.searchPh": "Rechercher une marque…",
  "vb.popular": "Marques les plus vendues",
  "vb.all": "Toutes les marques ({n})",
  "vb.models": { "one": "{n} modèle", "other": "{n} modèles" },
  "vb.brandTitle": "Pièces auto {b} pas cher — tous les modèles",
  "vb.brandFallback": "Marque de véhicule",
  "vb.brandH1": "Pièces auto {b}",
  "vb.brandStats": "{m} modèle(s) · {p} pièce(s) compatible(s)",
  "vb.brandExcerpt": "Choisissez votre modèle {b} ci-dessous, puis l'année et la motorisation pour n'afficher que les pièces qui conviennent exactement à votre véhicule.",
  "vb.brandEmpty": "Les modèles {b} arrivent bientôt.",
  "vb.selectVehicle": "Sélectionner un véhicule",
  "vb.topParts": "Pièces compatibles {b} les plus demandées",
  "vb.faqTitle": "Questions fréquentes sur {k}",
  "vb.faqParts": "les pièces {b}",
  "vb.notFound": "Marque introuvable.",
  "vb.seeAll": "Voir toutes les marques",
  "vm.notFound": "Modèle introuvable.",
  "vm.seeBrandModels": "Voir les modèles de la marque",
  "vm.useVehicle": "Utiliser ce véhicule pour tout le catalogue",
  "vm.shareParts": "Partager les pièces compatibles",
  "vm.share": "Partager…",
  "vm.empty": "Aucune pièce référencée pour ce modèle pour le moment.",
  "vm.otherModels": "Voir les autres modèles {b}",
  "vm.engineEmpty": "Aucune pièce référencée pour la motorisation « {e} ».",
  "vm.allEngines": "Voir toutes les motorisations",
  "vm.frequent": "Recherches fréquentes",
  "vm.wholeCategory": "Toute la catégorie",
  "vm.faqTitle": "Questions fréquentes — pièces {car}",
  "vm.faqFitQ": "Comment être sûr qu'une pièce convient à ma {car} ?",
  "vm.faqFitA": "Chaque pièce de cette page est référencée pour la {model}. Cliquez sur votre motorisation ci-dessus (ou saisissez votre plaque d'immatriculation sur l'accueil) : seules les références compatibles avec votre version restent affichées.",
  "vm.faqPartsQ": "Quelles pièces trouve-t-on pour la {car} ?",
  "vm.faqPartsA": "Le catalogue {model} couvre actuellement : {cats}. Il s'enrichit régulièrement de nouvelles références.",
  "vm.faqPartsEmpty": "Le catalogue {model} est en cours de constitution.",
  "vm.faqDeliveryQ": "Quels sont les délais de livraison ?",
  "vm.faqDeliveryA": "Les pièces en stock sont expédiées sous 24 h et livrées en 2 à 5 jours ouvrés. Vous pouvez aussi réserver un montage dans un centre partenaire lors de la commande.",
  "vm.h1": "Pièces auto {car}",
  "vm.intro": "Retrouvez ci-dessous toutes les pièces détachées vérifiées pour la {car}. Sélectionnez votre motorisation pour n'afficher que les références qui lui correspondent exactement.",
  "vm.stats": "{e} motorisation(s) · {p} pièce(s) compatible(s)",
  "vm.filtered": "{n} pièce(s){e}",
  "vm.forEngine": " pour {e}",
  "vm.added": "Ajouté au panier",
  "vm.addError": "Impossible d'ajouter au panier",
  "pp.noVehicleTitle": "Aucun véhicule sélectionné",
  "pp.noVehicleText": "Sélectionnez votre véhicule pour afficher uniquement les pièces compatibles.",
  "pp.selectVehicle": "Sélectionner mon véhicule",
  "pp.backHome": "Retour à l'accueil",
  "pp.title": "Pièces compatibles avec votre véhicule",
  "pp.metaTitle": "Pièces auto compatibles avec votre véhicule",
  "pp.metaDesc": "Sélectionnez votre véhicule (marque, modèle, motorisation ou plaque) et découvrez les pièces détachées 100 % compatibles sur OTOPIECES.COM.",
  "pp.metaTitleVehicle": "Pièces auto {v}",
  "pp.metaDescVehicle": "Toutes les pièces détachées compatibles avec votre {v} : freinage, filtration, moteur, embrayage… au meilleur prix sur OTOPIECES.COM.",
  "pp.categories": "Catégories",
  "br.title": "Les modèles les moins chers à entretenir : classement du budget pièces annuel",
  "br.h1": "Les modèles les moins chers à entretenir",
  "br.crumb": "Budget entretien",
  "br.metaDefault": "Classement des modèles de véhicules par budget entretien annuel estimé à partir des pièces compatibles.",
  "br.meta": "Classement de {n} modèles par budget entretien annuel estimé (pièces d'usure compatibles × fréquence habituelle). Du plus économique ({min}/an) au plus coûteux ({max}/an), hors main-d'œuvre.",
  "br.intro": "Pour chaque modèle, nous estimons le budget annuel en pièces d'entretien à partir des pièces compatibles référencées sur OTOPIECES.COM : filtres, freinage, bougies, courroies, amortisseurs… multipliés par leur fréquence de remplacement habituelle. Prix médian des pièces compatibles, ou budget « éco » avec la pièce la moins chère. Hors main-d'œuvre, toutes motorisations confondues.",
  "br.error": "Classement indisponible pour le moment.",
  "br.allBrands": "Toutes les marques ({n})",
  "br.itemStats": "{p} postes estimés sur {pt} · {n} pièces compatibles · {e} motorisations",
  "br.perYear": "/ an",
  "br.eco": "éco {v} / an",
  "br.footnote": "Classement recalculé chaque nuit{d}. Estimations indicatives, hors main-d'œuvre.",
  "br.lastUpdate": " · dernière mise à jour {d}",
  "br.ctaQ": "Vous possédez l'un de ces modèles ?",
  "br.ctaLink": "Ajoutez-le à votre garage",
  "br.ctaRest": " pour un budget sur votre motorisation exacte, un carnet d'entretien et des rappels par e-mail.",
  "br.faqTitle": "Questions fréquentes",
  "br.faq1q": "Comment est calculé le budget entretien ?",
  "br.faq1a": "Nous retenons 22 postes d'usure (vidange, filtres, plaquettes, disques, bougies, courroies, distribution, amortisseurs…). Pour chaque poste, le prix médian des pièces compatibles référencées est divisé par la fréquence de remplacement habituelle (ex. plaquettes tous les 2 ans). La somme donne le budget annuel lissé. Un modèle n'entre au classement qu'avec au moins 3 postes estimés.",
  "br.faq2q": "Quel est le modèle le moins cher à entretenir ?",
  "br.faq2a": "D'après nos estimations, {car} arrive en tête avec environ {m} de pièces d'entretien par an au prix médian ({e} en éco). La médiane des {n} modèles classés est de {med}/an.",
  "br.faq3q": "Le budget inclut-il la main-d'œuvre ?",
  "br.faq3a": "Non : il s'agit uniquement du budget pièces, toutes motorisations confondues. Ajoutez votre véhicule à votre garage pour obtenir un budget sur votre motorisation exacte, un carnet d'entretien avec échéances en mois et en kilomètres, et des rappels par e-mail.",
  "cm.pickError": "Choisissez deux ou trois véhicules à comparer depuis votre garage.",
  "cm.failed": "Comparaison impossible",
  "cm.title": "Comparatif pièces : {v}",
  "cm.meta": "Pièces compatibles communes et spécifiques entre {v}.",
  "cm.crumbGarage": "Mon garage",
  "cm.crumb": "Comparatif modèles",
  "cm.parts": "{n} pièce(s)",
  "cm.forThisEngine": " pour cette motorisation",
  "cm.engines": " · {n} motorisation(s)",
  "cm.budget": "Budget entretien ~{m} €/an",
  "cm.budgetEco": "(éco {e} €)",
  "cm.cheapest": "le moins coûteux à entretenir",
  "cm.budgetNone": "Budget entretien non estimé",
  "cm.part": "Pièce",
  "cm.price": "Prix",
  "cm.exactEngine": "Ma motorisation exacte",
  "cm.allEngines": "Toutes les motorisations du modèle",
  "cm.exactHint": "Seules les pièces prévues pour la motorisation de chaque véhicule (ou sans restriction de moteur) sont comparées.",
  "cm.allHint": "Toutes les pièces du modèle sont comparées, quelle que soit la motorisation.",
  "cm.all": "Tout ({n})",
  "cm.common2": "Communes aux deux ({n})",
  "cm.common3": "Communes aux trois ({n})",
  "cm.partial": "Communes à deux sur trois ({n})",
  "cm.only": "{m} uniquement ({n})",
  "cm.onlyCol": "{m} uniquement",
  "cm.common2Col": "Communes aux deux",
  "cm.empty": "Aucune pièce dans cette sélection.",
  "wl.title": "Ma liste de souhaits",
  "wl.empty": "Aucune pièce enregistrée. Cliquez sur le cœur d'un produit pour le retrouver ici.",
  "acc.addressIntro": "Vos adresses sont proposées au moment de la commande. L'adresse de livraison par défaut est pré-remplie automatiquement.",
  "acc.walletIntro": "Votre compte de dépôt est alimenté par notre service client (remboursement en avoir, geste commercial, bon d'achat).",
  "acc.prefsNote": "La boutique est proposée en 5 langues et en euros ; vos préférences sont mémorisées.",
  "acc.proHt": "Prix HT affichés",
  "acc.proInvoices": "Factures au nom de votre société",
  "acc.proBadge": "Badge Pro sur votre compte",
  "va.title": "Alertes véhicule",
  "va.intro": "Recevez un e-mail lorsque de nouvelles pièces compatibles avec vos modèles sont ajoutées — en résumé hebdomadaire (lundi) ou à chaque ajout.",
  "va.empty": "Aucune alerte véhicule. Activez-en une depuis la page d'un modèle.",
  "va.browse": "Parcourir les véhicules",
  "auth.showPassword": "Afficher le mot de passe",
  "brands.kicker": "Nos fabricants",
  "brand.empty": "Aucun produit {b}{cat}{veh}.",
  "brand.emptyCat": " dans cette catégorie",
  "brand.emptyVeh": " compatible avec votre véhicule",
  "brand.seeUnfiltered": "Voir les {n} produits non filtrés par véhicule",
  "brand.relatedSearches": "Recherches associées",
  "cmp.pageTitle": "Comparaison de produits",
  "common.new": "Nouveau",
  "vm.metaDesc": "Toutes les pièces détachées compatibles {car} : {cats}. {e} motorisation(s) ({engines}…). Compatibilité vérifiée, livraison 2-5 jours.",
  "ship.title": "Livraison & suivi",
  "ship.metaDesc": "Délais, frais de port et transporteurs OTOPIECES.COM.",
  "ship.metaFree": "Livraison gratuite dès {free}.",
  "ship.eyebrow": "Livraison",
  "ship.heading": "Livraison rapide et suivie",
  "ship.headingFree": "Livraison rapide, suivie, gratuite dès {free}",
  "ship.intro": "Expédition sous 24 h ouvrées depuis notre entrepôt en France. Choisissez le transporteur qui vous convient.",
  "ship.fees": "Frais de port",
  "ship.feesFree": "{fee} · offerts dès {free}",
  "ship.avgDelay": "Délai moyen",
  "ship.avgDelayValue": "2 à 5 jours ouvrés",
  "ship.insured": "Colis assuré",
  "ship.insuredValue": "Casse ou perte remboursée",
  "ship.how": "Comment ça se passe ?",
  "ship.s1": "Commande validée",
  "ship.s1Text": "Confirmation immédiate par e-mail avec votre numéro de commande.",
  "ship.s2": "Préparation",
  "ship.s2Text": "Pièces contrôlées et emballées sous 24 h ouvrées dans notre entrepôt.",
  "ship.s3": "Expédition",
  "ship.s3Text": "E-mail avec le numéro de suivi et le lien du transporteur.",
  "ship.s4": "Livraison",
  "ship.s4Text": "À domicile, au garage ou en point relais selon votre choix.",
  "ship.carriers": "Nos transporteurs",
  "ship.c1Delay": "2–4 jours ouvrés",
  "ship.c1Note": "Livraison à domicile ou en bureau de poste",
  "ship.c2Delay": "24–48 h",
  "ship.c2Note": "Express, idéal pour les urgences atelier",
  "ship.c3Delay": "2–3 jours ouvrés",
  "ship.c3Note": "Colis volumineux (pare-chocs, capots…)",
  "ship.c4Delay": "3–5 jours ouvrés",
  "ship.c4Note": "Retrait en point relais, économique",
  "ship.trackingKicker": "Suivi de colis",
  "ship.trackingTitle": "Où en est ma commande ?",
  "ship.trackingText": "Retrouvez le statut, le transporteur et le numéro de suivi dans votre espace client.",
  "ship.trackCta": "Suivre ma commande",
  "cat.metaSubFallback": "{sub} ({cat}) au meilleur prix sur OTOPIECES.COM : {brands}, compatibilité garantie avec votre véhicule, livraison 2-5 jours, retour 14 jours.",
  "cat.metaFallback": "Achetez vos pièces {cat} au meilleur prix sur OTOPIECES.COM : grandes marques ({brands}), compatibilité garantie avec votre véhicule, livraison 2-5 jours.",
  "vg.today": "aujourd’hui",
  "vg.budgetInline": "budget entretien ~{m} €/an",
  "vg.engines": "Motorisations {m}",
  "vg.allN": "Toutes ({n})",
  "vg.popular": "Populaire",
  "vg.engAbbr": "{n} mot.",
  "vg.choose": "Choisir",
  "vg.parts": "Pièces",
  "vg.seeParts": "Voir toutes les pièces compatibles {m}",
  "vg.allModels": "Tous les modèles {b}",
  "vg.searchModel": "Rechercher un modèle…",
  "vg.gallery": "Galerie",
  "vg.list": "Liste",
  "vg.noMatch": "Aucun modèle ne correspond à « {q} ».",
  "vg.popularTitle": "Modèles {b} les plus recherchés",
  "vg.popularByUsage": "Selon les sélections et les garages de nos clients.",
  "vg.popularByParts": "Les modèles avec le plus de pièces disponibles.",
  "vg.generations": { "one": "{n} génération", "other": "{n} générations" },
  "vg.yearsEstimated": "* années indicatives",
  "mb.title": "Budget entretien annuel estimé — {car}",
  "mb.intro": "Estimation à partir des {n} pièces d'usure compatibles référencées ({p} postes sur {pt}), toutes motorisations confondues : prix médian, ou « éco » avec la pièce la moins chère, rapporté à la fréquence de remplacement habituelle.",
  "mb.eco": "Éco : {v} / an",
  "mb.hideDetail": "Masquer le détail",
  "mb.showDetail": "Voir le détail par poste",
  "mb.rankingLink": "Voir le classement des modèles les moins chers à entretenir",
  "mb.garageLink": "Ajoutez ce véhicule à votre garage pour un budget sur votre motorisation exacte et un carnet d'entretien",
  "mb.colItem": "Poste",
  "mb.colFreq": "Fréquence",
  "mb.colEco": "Éco",
  "mb.colMedian": "Prix médian",
  "mb.colYear": "Par an",
  "mb.every": { "one": "tous les ans", "other": "tous les {n} ans" },
  "mb.missing": "Non estimés (pas encore de pièce compatible) : {list}",
  "val.cta": "M'alerter des nouvelles pièces",
  "val.activated": "Alerte activée ({f}{e}) !",
  "val.weeklyShort": "résumé hebdo",
  "val.instantShort": "à chaque ajout",
  "val.already": "Alerte déjà active",
  "val.active": "Alerte nouvelles pièces active",
  "val.disable": "Désactiver",
  "val.formTitle": "Recevoir un e-mail quand de nouvelles pièces compatibles sont ajoutées",
  "val.emailPh": "votre@email.fr",
  "val.enable": "Activer",
  "val.onlyEngine": "Uniquement ma motorisation",
  "val.weekly": "Résumé hebdomadaire (lundi)",
  "val.instant": "À chaque ajout",
  "val.error": "Impossible d'activer l'alerte, vérifiez l'adresse e-mail.",
  "val.notifyWhenAdded": "Me prévenir dès qu'une pièce est ajoutée",
  "gar.alertEnabledNote": "Alerte « nouvelles pièces » activée (résumé hebdo).",
  "gar.alertOptIn": "M'alerter par e-mail des nouvelles pièces compatibles avec ce véhicule",
  "gar.alertOptInHint": "(résumé hebdomadaire, modifiable dans Mes alertes)",
  "vb.brandMeta": "Pièces détachées {b} : {m} modèles ({fams}…) et {p} pièces compatibles au meilleur prix. Freinage, filtration, moteur, pneus.",
  "vb.partsInCat": "Pièces {c} {b} ({n})",
  "vb.allParts": "Toutes les pièces",
  "vb.noPartsInCat": "Aucune pièce de cette catégorie pour cette marque pour le moment.",
  "vb.modelFilter": "Filtrer par modèle",
  "vb.allModelsOpt": "Tous les modèles",
  "vb.partsForModel": "Pièces compatibles {b} ({n})",
  "vb.modelPage": "Fiche du modèle",
  "vb.noPartsForModel": "Aucune pièce de cette catégorie compatible avec ce modèle pour le moment.",
  "vb.modelsWithParts": "Modèles avec pièces référencées",
  "vb.modelsOther": "Autres modèles",
  "vb.engineFilter": "Filtrer par motorisation",
  "vb.allEnginesOpt": "Toutes les motorisations",
  "fuel.essence": "Essence", "fuel.diesel": "Diesel", "fuel.hybride": "Hybride", "fuel.essence/électrique": "Hybride essence", "fuel.diesel/électrique": "Hybride diesel", "fuel.électrique": "Électrique", "fuel.gpl": "GPL",
  "fuel.essence/gpl": "Essence / GPL", "fuel.essence/éthanol": "Essence / éthanol",
  "vb.garageAdd": "Ajouter à mon garage",
  "vb.garageSee": "Dans mon garage — voir",
  "vb.garageAdded": "{car} ajouté à votre garage.",
  "vb.garageAlready": "Ce véhicule est déjà dans votre garage.",
  "vb.garageError": "Impossible d'ajouter ce véhicule.",
  "vb.garageLoginHint": "Connectez-vous pour enregistrer ce véhicule dans votre garage",
  "vb.alertCta": "M'alerter des nouvelles pièces {m}",
  "vb.share": "Partager cette sélection",
  "vb.shareText": "Pièces compatibles {sel} sur OTOPIECES.COM",
  "vb.shareCopied": "Lien de la sélection copié dans le presse-papiers.",
  "vb.shareCopiedShort": "Lien copié",
  "vb.shareCopyManual": "Copiez ce lien :",
  "vb.shareCheapest": "Les 3 pièces les moins chères :",
  "vb.shareWhatsappHint": "Envoyer la sélection et les 3 pièces les moins chères par WhatsApp",
  "fuelR.title": "Énergie",
  "fuelR.all": "Toutes motorisations",
  "fuelR.essence": "Essence",
  "fuelR.diesel": "Diesel",
  "fuelR.electrique": "100 % électrique",
  "fuelR.reserved": "Réservé aux moteurs :",
  "fuelR.vehicleHint": "Tri pertinence : les pièces {e} de votre véhicule d'abord",
  "product.fitFuelKo": "Réservé aux moteurs {e} — votre véhicule est {ve}",
  "cart.fitFuel": "Réservé {e} · votre {v} est {ve}",
  "garage.additivesTitle": "Additifs recommandés",
  "garage.additivesHint": "Additifs et nettoyants adaptés à l'énergie de chacun de vos véhicules.",
  "garage.additivesEmpty": "Aucun additif compatible pour le moment.",
  "garage.additiveHint": "Pensez à l'additif :",
  "packEss.title": "Pack entretien essence",
  "packEss.onAdditive": "sur l'additif",
  "packEss.desc": "Cette huile + un additif carburant essence : -{p} % sur l'additif, remise appliquée automatiquement au paiement.",
  "packEss.total": "Le lot :",
  "packEss.add": "Ajouter le lot au panier",
  "packEss.done": "Lot ajouté",
  "packEss.added": "Lot ajouté au panier — code {c} appliqué",
  "packEss.addedLogin": "Lot ajouté — la remise {c} s'appliquera au paiement après connexion",
  "packEss.code": "Remise via le code {c}, valable avec une huile moteur dans le panier.",
  "packEss.titleDiesel": "Pack entretien diesel",
  "packEss.descDiesel": "Cette huile + un additif diesel ou nettoyant FAP : -{p} % sur l'additif, remise appliquée automatiquement au paiement.",
  "packEss.cartDesc": "Votre huile moteur est seule dans le panier : complétez le lot avec l'additif adapté, -{p} % dessus.",
  "packEss.cartAdd": "Ajouter l'additif au lot (-{p} %)",
};

export default fr;
